<template>

  <div class="item-list-view flex flex-wrap" vs-w="12">
    
  
    <!-- 検索結果の表示（検索ページ） -->
    <template v-if="readFirebaseItem === 'search'">
      <div class="searchCheckbox">
        <vx-card>
          <div v-if="searchError.length > 0" class="error-message">
            <ul>
              <li v-for="error in searchError">{{error}}</li>
            </ul>
          </div>

          <div class="searchForm02">

            <div class="form-wrap w-4/12">
              <div class="form-inner keyword-wrap">
                <span class="ttl">キーワード</span>
                <div class="input-wrap w-full">
                  <vs-input type="text" v-bind:class="[searchError.length > 0 ? 'is-error' : '']" v-model="searchText" @focus="suggestDisplay = true" @blur="suggestReset($event),searchDetailProducts(true)" placeholder="キーワード、JAN、ISBN、ASINを入力。複数は間に,で区切る" value=""/>
                   <ul tabindex="-1" class="search-suggest-list" v-if="suggestDisplay && suggestArr.length > 0">
                    <li v-for="item in suggestArr" :item="item" @click="suggestWordSelect(item)">{{item}}</li>
                  </ul>
                </div>
              </div>
              <div class="form-inner category-wrap">
                <span class="ttl">カテゴリ</span>
                <div class="input-wrap w-full">
                  <v-select v-model="searchForm.category" :options="searchCategory" @input="searchDetailProducts(true)"/></v-select>
                </div>
              </div>
              <div class="form-inner lg:w-8/12">
                <span class="ttl">ランキング</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_SALES_gte" @blur="searchDetailProducts(true)" class="input-number" value="1"/>
                </div>
                <span class="item">〜</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_SALES_lte" @blur="searchDetailProducts(true)" class="input-number" value="1"/>
                </div>
                <span class="item">位</span>
              </div>
              <div class="form-inner lg:w-4/12 w-full">
                <div class="input-wrap w-full checkbox-wrap">
                  <vs-checkbox v-model="searchForm.is_Amazon_outOfStock" @change="searchDetailProducts(true)"></vs-checkbox><div class="ttl">Amazon在庫を除外</div>
                </div>
              </div>
            </div>
            

            <div class="form-wrap w-4/12 ">
              <div class="form-inner">
                <span class="ttl"><span class="color-new">新品 </span>価格</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_NEW_gte" v-bind:disabled="searchForm.is_New_outOfStock" class="input-number"  @blur="searchDetailProducts(true)"/>
                </div>
                <span class="item">〜</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_NEW_lte" v-bind:disabled="searchForm.is_New_outOfStock" class="input-number"  @blur="searchDetailProducts(true)"/>
                </div>
                <span class="item">円</span>
              </div>
              <div class="form-inner">
                <span class="ttl"><span class="color-new">新品 </span>90日間の値下り / 値上り率</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.deltaPercent90_NEW_gte" class="input-number"  @blur="searchDetailProducts(true)"/>
                </div>
                <span class="item">〜</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.deltaPercent90_NEW_lte" class="input-number"  @blur="searchDetailProducts(true)"/>
                </div>
                <span class="item">％</span>
              </div>
              <div class="form-inner lg:w-8/12">
                <span class="ttl"><span class="color-new">新品 </span>出品者数</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_COUNT_NEW_gte" class="input-number"  @blur="searchDetailProducts(true)"/>
                </div>
                <span class="item">〜</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_COUNT_NEW_lte" class="input-number"  @blur="searchDetailProducts(true)"/>
                </div>
                <span class="item">人</span>
              </div>
              <div class="form-inner lg:w-4/12">
                <div class="input-wrap w-full checkbox-wrap">
                  <vs-checkbox v-model="searchForm.is_New_outOfStock" @change="searchDetailProducts(true)"></vs-checkbox><div class="ttl"><span class="color-new">新品 </span>在庫なし</div>
                </div>
              </div>
            </div>

            <div class="form-wrap w-4/12 ">
              <div class="form-inner ">
                <span class="ttl"><span class="color-used">中古 </span>価格</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_USED_gte" v-bind:disabled="searchForm.is_Used_outOfStock" class="input-number" value="1"/>
                </div>
                <span class="item">〜</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_USED_lte" v-bind:disabled="searchForm.is_Used_outOfStock" class="input-number" value="1"/>
                </div>
                <span class="item">円</span>
              </div>
              <div class="form-inner ">
                <span class="ttl"><span class="color-used">中古 </span>90日間の値下り / 値上り率</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.deltaPercent90_USED_gte" class="input-number" value="1"/>
                </div>
                <span class="item">〜</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.deltaPercent90_USED_lte" class="input-number" value="1"/>
                </div>
                <span class="item">％</span>
              </div>
              <div class="form-inner lg:w-8/12">
                <span class="ttl"><span class="color-used">中古 </span>出品者数</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_COUNT_USED_gte" class="input-number" value="1"/>
                </div>
                <span class="item">〜</span>
                <div class="input-wrap">
                  <vs-input type="number" v-model.number="searchForm.current_COUNT_USED_lte" class="input-number" value="1"/>
                </div>
                <span class="item">人</span>
              </div>
              <div class="form-inner lg:w-4/12">
                <div class="input-wrap w-full checkbox-wrap">
                  <vs-checkbox v-model="searchForm.is_Used_outOfStock" @change="searchDetailProducts(true)"></vs-checkbox><div class="ttl"><span class="color-used">中古 </span>在庫なし</div>
                </div>
              </div>
            </div>
          </div>
          <div class="searchSubmit">
            <vs-button color="warning" type="filled" @click="detailSearch(true)">検索する</vs-button>
            <vs-button color="primary" type="filled" class="" @click="searchDetailReset()">条件をリセット</vs-button>
            <span class="totalResults">該当数：{{searchTotalResults}} 件</span>
          </div>
        </vx-card>
      </div>
    </template>
    <template v-if="searchArr.length > 0 && readFirebaseItem === 'search'">
      <vs-col vs-type="flex" vs-justify="between" id="searchContainer" class=" content-wrap flex-wrap">
        <vx-card class="list-view-item overflow-hidden" v-for="(item, index) in searchArr" :item="item">
          <div class="vx-row item-details item-list no-gutter ">
            <div class="vx-col vx-row w-8/12 w-full item-details-container no-hover">
              <!-- IMG COL -->
              <div class="vx-col w-3/12 item-img-container bg-white flex items-center justify-center flex-wrap">
                <img v-if="typeof item.thumb !== 'undefined'" v-lazy="item.thumb" :alt="item.title" class="grid-view-img p-4">
                <div class="w-full text-center" v-if="typeof item.ranking > 0">{{item.ranking}}位</div>
              </div>
              <!-- ITEM NAME & DESC COL -->
              <div class="vx-col w-9/12 item-detail-container">
                <div class="detail-container">
                  <slot name="item-meta">
                    <div class="clearfix">
                      <vs-chip color="primary" v-if="item.cat !== ''">{{item.cat}}</vs-chip>
                    </div>
                    <h6 class="item-name font-semibold mt-2 mb-1">{{item.title}}</h6>
                    <p class="item-asin text-sm mb-2">

                      <template v-if="item.asin !== ''">ASIN : {{item.asin}}</template>
                      <template v-if="item.codeType == 'ISBN' || item.codeType == 'JAN' || item.codeType == 'EAN'">
                        / JAN: {{item.code}}
                      </template>
                      <template v-else-if="item.jan">
                        / JAN: {{item.jan}}　
                      </template>

                    </p>
                    <div class="star-wrap mb-2" v-if="item.rating > 0">
                      <star-rating :show-rating="false" :rating="item.rating" :star-size="20" read-only />
                      <span class="number" v-if="item.review != 0">（{{item.review}}）</span>
                    </div>
                    <p class="item-description text-sm" v-if="item.price > 0">参考価格: {{item.price.toLocaleString()}}円</p>
                  </slot>
                </div>
              </div>
              <feather-icon icon="ChevronRightIcon" class="arrow-icon" svgClasses="w-8 h-8" />
            </div>
            <div class="vx-col w-4/12 item-graph-container">
              <div class="graph-detail cursor-pointer" @click="dataGraphVisible(item.asin)">
                <span class="text-warning">●&nbsp;Amazon</span>
                <span class="text-primary">●&nbsp;新品</span>
                <span class="">●&nbsp;中古</span>
                <span class="text-success">●&nbsp;ランキング</span>
              </div>
              <div class="img cursor-pointer" @click="dataGraphVisible(item.asin)"><img v-lazy="'https://us-central1-amacode-1afb2.cloudfunctions.net/keepaGraph?asin=' + item.asin" alt="loading..."><span class="load">loading...</span></div>
              <vs-button color="warning" type="filled" class="" @click="dataGraphVisible(item.asin)">グラフを見る</vs-button>
            </div>
          </div>
          <vs-divider/>
          
          <div class="vx-row text-center price-wrap">
            <div class="vx-col w-1/3 price-item">
              <h4 class="w-full price">
                <template v-if="item.cartPrice > 0">
                  {{item.cartPrice.toLocaleString()}}
                  <span class="unit">円</span>
                </template>
                <template v-else>---</template>
              </h4>
              <div class="mt-1 ttl">カート<template v-if="item.isCartPrime"><div class="chip-wrap"><vs-chip color="dark">F</vs-chip></div></template></div>
            </div>
            <div class="vx-col w-1/3 price-item">
              <h4 class="w-full price">
                <template v-if="item.newPrice > 0">
                  {{item.newPrice.toLocaleString()}}<span class="unit">円</span>
                </template>
                <template v-else>---</template>
              </h4>
              <div class="mt-1 ttl">
                新品({{item.newCount}}件)
                <template v-if="item.isNewPrime"><div class="chip-wrap"><vs-chip color="dark">F</vs-chip></div></template>
              </div>
            </div>
            <div class="vx-col w-1/3 price-item">
              <h4 class="w-full price">
                <template v-if="item.usedPrice > 0">
                  {{item.usedPrice.toLocaleString()}}<span class="unit">円</span>
                </template>
                <template v-else>---</template>
              </h4>
              <div class="mt-1 ttl">
                中古({{item.usedCount}}件)
                <template v-if="item.isUsedPrime"><div class="chip-wrap"><vs-chip color="dark">F</vs-chip></div></template>
              </div>
            </div>
          </div>
          <vs-divider class="mb-1" />
          <div class=" text-center button-wrap" v-if="customOption.length > 0">
            <template v-for="customButton in customOption" >
              <div class=" button" v-if="customButton.isShow">
                <vs-button color="primary" type="filled" v-if="customButton.actionType === 0 || customButton.actionType === 1 || typeof customButton.actionType === 'undefined'" target @click='customButtonUrl(customButton,item.asin)'>
                  <template v-if="customButton.key == 'amazon'" ><i class="fa fa-amazon"></i></template>
                  <template v-if="customButton.key == 'denno'" ><i class="fa fa-flash"></i></template>
                  <template v-if="customButton.key == 'kakakucom'" ></template>
                  <template v-if="customButton.key != 'amazon' && customButton.key != 'denno' && customButton.key != 'kakakucom'"><i class="fa" :class="customButton.icon"></i></template>
                  {{customButton.name}}</vs-button>
                <vs-button color="primary" type="filled" v-if="customButton.actionType === 2" @click='customButtonMail(customButton.contentTitle,customButton.contentBody,item.asin)'><i class="fa" :class="customButton.icon"></i>{{customButton.name}}</vs-button>
                <vs-button color="primary" type="filled" v-if="customButton.actionType === 3" @click='clipCopy(customButton.contentBody,item.asin)'><i class="fa" :class="customButton.icon"></i>{{customButton.name}}</vs-button>
              </div>
            </template>
          </div>
          <div class="text-center button-wrap" v-else>
            <div class=" button">
              <vs-button color="primary" type="filled" target :href='"https://www.amazon.co.jp/o/ASIN/"+item.asin+"/amacode-22"'><i class="fa fa-amazon"></i>Amazon</vs-button>
            </div>
            <div class=" button">
              <vs-button color="primary" type="filled" target :href='"https://denno-s.com/?code="+item.asin'><i class="fa fa-flash"></i>電脳サーチ</vs-button>
            </div>
            <div class=" button">
              <vs-button color="primary" type="filled" target :href='"https://amacode.app/kakakucom.php?keyword="+item.name'>価格com</vs-button>
            </div>
            <div class=" button">
              <vs-button color="primary" type="filled" target :href='"https://amacode.app/aucfan-web.php?keyword="+item.name'>オークファン</vs-button>
            </div>
          </div>
        </vx-card>
      </vs-col>
      <p class="text-center w-full">{{searchDetail}}</p>

      <!-- 無限スクロール（検索製品）の判定DOM -->
      <div class="loadingSpinner" v-if="!logdingFlag || loadEndFlag || !loadingEndFlag"><img src="@/assets/images/common/tail-spin.svg"></div>
      <infinite-loading @infinite="searchInfiniteHandler" v-if="!logdingFlag || loadingEndFlag" spinner="spiral">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>

      <!-- 無限スクロール（ページ）の判定DOM -->
      <infinite-loading @infinite="searchInfinitePageHandler" v-if="loadEndFlag || loadingEndFlag" spinner="spiral">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>

      <p class="text-center w-full mt-8 mb-6" v-if="loadingEndFlag">検索商品は以上です</p>
    </template>
    <template v-if="searchArr.length === 0 && !logdingFlag && readFirebaseItem === 'search'">
      <p class="no-data">データが見つかりませんでした</p>
    </template>


    <!-- 商品一覧の表示（商品履歴・仕入れページ） -->
    <template v-if="readFirebaseItem.indexOf('search') === -1">
      <vs-col vs-type="flex" vs-justify="between" id="contentLoad" class="vs-con-loading__container content-wrap flex-wrap">
        <vx-card class="list-view-item overflow-hidden" v-for="item in itemHistoryArr" :item="item">
          <div class="vx-row item-details item-list no-gutter ">
            <div class="vx-col vx-row w-8/12 item-details-container no-hover" >
              <!-- IMG COL -->
              <div class="vx-col w-3/12 item-img-container bg-white flex items-center justify-center flex-wrap cursor-pointer" @click="dataVisible(item)">
                <img v-lazy="item.thumbUrl" :alt="item.name" class="grid-view-img">
                <div class="w-full text-center mt-1" v-if="typeof item.info !== 'undefined' && typeof item.info.SalesRankings !== 'undefined'">
                  <template v-if="item.info.SalesRankings.SalesRank.length > 0">{{item.info.SalesRankings.SalesRank[0].Rank}}</template>
                  <template v-else>{{item.info.SalesRankings.SalesRank.Rank}}</template>位
                </div>
                <div class="w-full text-success text-center font-semibold mt-1" v-if="item.arariprice !== ''">粗:{{item.arariprice.toLocaleString()}}円</div>
                <div class="w-full text-center">
                  <vs-button color="warning" type="filled" class="mt-4" >仕入れ・出品</vs-button>
                </div>
              </div>
              <!-- ITEM NAME & DESC COL -->
              <div class="vx-col w-9/12 item-detail-container">
                <div class="detail-container">
                  <slot name="item-meta">
                    <div class="clearfix">
                      <vs-chip color="primary" v-if="item.catName !== ''">{{item.catName}}</vs-chip>
                      <template v-if="itemHistory[item.asin].asstype !== 'undefined'">
                        <template v-if="itemHistory[item.asin].asstype === 0">
                          <vs-chip>出品処理</vs-chip>
                        </template>
                        <template v-if="itemHistory[item.asin].asstype === 1">
                          <vs-chip color="warning">出品済み</vs-chip>
                        </template>
                        <template v-if="itemHistory[item.asin].asstype === 2">
                          <vs-chip color="danger">出品エラー</vs-chip>
                        </template>
                      </template>
                    </div>
                    <h6 class="item-name font-semibold mt-2 mb-1">{{item.name}}</h6>
                    <p class="item-asin text-sm mb-2">
                      
                      <template v-if="item.asin !== ''">ASIN : {{item.asin}}</template>
                      <template v-if="item.codeType == 'ISBN' || item.codeType == 'JAN' || item.codeType == 'EAN'">
                        / JAN: {{item.code}}
                      </template>
                      <template v-else-if="item.jan">
                        / JAN: {{item.jan}}　
                      </template>
                      
                    </p>
                    <div class="star-wrap mb-2" v-if="item.reviewStart < 5">
                      <star-rating :show-rating="false" :rating="Math.floor(item.reviewStart)" :star-size="20" read-only />
                      <span class="number" v-if="item.reviewCount != 0">（{{item.reviewCount}}）</span>
                    </div>
                    <p class="item-description text-sm" v-if="item.price > 0">参考価格: {{item.price.toLocaleString()}}円</p>
                  </slot>
                </div>
              </div>
              <feather-icon icon="ChevronRightIcon" class="arrow-icon" svgClasses="w-8 h-8" />
            </div>
            <div class="vx-col w-4/12 item-graph-container">
              <div class="graph-detail cursor-pointer" @click="dataGraphVisible(item.asin)">
                <span class="text-warning">●&nbsp;Amazon</span>
                <span class="text-primary">●&nbsp;新品</span>
                <span class="">●&nbsp;中古</span>
                <span class="text-success">●&nbsp;ランキング</span>
              </div>
              <div class="img cursor-pointer" @click="dataGraphVisible(item.asin)"><img v-lazy="'https://us-central1-amacode-1afb2.cloudfunctions.net/keepaGraph?asin=' + item.asin" alt="loading..."><span class="load">loading...</span></div>
              <vs-button color="warning" type="filled" class="" @click="dataGraphVisible(item.asin)">グラフを見る</vs-button>
            </div>
          </div>
          <vs-divider />
          <div class="vx-row text-center price-wrap">
            <div class="vx-col w-1/3 price-item">
              <h4 class="w-full price">
                <template v-if="typeof item.cart !== 'undefined' && typeof item.cart.CompetitivePrices !== 'undefined'">
                  {{Math.round(item.cart.CompetitivePrices.CompetitivePrice.Price.LandedPrice.Amount).toLocaleString()}}
                  <span class="unit">円</span>
                </template>
                <template v-else>---</template>
              </h4>
              <div class="mt-1 ttl">カート</div>
            </div>
            <div class="vx-col w-1/3 price-item">
              <h4 class="w-full price">
                <template v-if="getPriceFirst(item, true).price > 0">
                  {{Math.round(getPriceFirst(item, true).price).toLocaleString()}}<span class="unit">円</span>
                </template>
                <template v-else>---</template>
              </h4>
              <div class="mt-1 ttl">
                新品({{getItemCount(item, true)}}件)
                <template v-if="getPriceFirst(item, true).shipping === 'FBA'"><div class="chip-wrap"><vs-chip color="dark">F</vs-chip></div></template>
              </div>
            </div>
            <div class="vx-col w-1/3 price-item">
              <h4 class="w-full price">
                <template v-if="getPriceFirst(item, false).price > 0">
                  {{Math.round(getPriceFirst(item, false).price).toLocaleString()}}<span class="unit">円</span>
                </template>
                <template v-else>---</template>
              </h4>
              <div class="mt-1 ttl">
                中古({{getItemCount(item, false)}}件)
                <template v-if="getPriceFirst(item, false).shipping === 'FBA'"><div class="chip-wrap"><vs-chip color="dark">F</vs-chip></div></template>
              </div>
            </div>
          </div>
          <vs-divider class="mb-1" />
          <div class=" text-center button-wrap" v-if="customOption.length > 0">
            <template v-for="customButton in customOption" >
              <div class=" button" v-if="customButton.isShow">
                <vs-button color="primary" type="filled" v-if="customButton.actionType === 0 || customButton.actionType === 1 || typeof customButton.actionType === 'undefined'" target @click='customButtonUrl(customButton,item.asin)'>
                  <template v-if="customButton.key == 'amazon'" ><i class="fa fa-amazon"></i></template>
                  <template v-if="customButton.key == 'denno'" ><i class="fa fa-flash"></i></template>
                  <template v-if="customButton.key == 'kakakucom'" ></template>
                  <template v-if="customButton.key != 'amazon' && customButton.key != 'denno' && customButton.key != 'kakakucom'"><i class="fa" :class="customButton.icon"></i></template>
                  {{customButton.name}}</vs-button>
                <vs-button color="primary" type="filled" v-if="customButton.actionType === 2" @click='customButtonMail(customButton.contentTitle,customButton.contentBody,item.asin)'><i class="fa" :class="customButton.icon"></i>{{customButton.name}}</vs-button>
                <vs-button color="primary" type="filled" v-if="customButton.actionType === 3" @click='clipCopy(customButton.contentBody,item.asin)'><i class="fa" :class="customButton.icon"></i>{{customButton.name}}</vs-button>
              </div>
            </template>
          </div>
          <div class="text-center button-wrap" v-else>
            <div class=" button">
              <vs-button color="primary" type="filled" target :href='"https://www.amazon.co.jp/o/ASIN/"+item.asin+"/amacode-22"'><i class="fa fa-amazon"></i>Amazon</vs-button>
            </div>
            <div class=" button">
              <vs-button color="primary" type="filled" target :href='"https://denno-s.com/?code="+item.asin'><i class="fa fa-flash"></i>電脳サーチ</vs-button>
            </div>
            <div class=" button">
              <vs-button color="primary" type="filled" target :href='"https://amacode.app/kakakucom.php?keyword="+item.name'>価格com</vs-button>
            </div>
            <div class=" button">
              <vs-button color="primary" type="filled" target :href='"https://amacode.app/aucfan-web.php?keyword="+item.name'>オークファン</vs-button>
            </div>
          </div>
        </vx-card>
      </vs-col>

      

      <div class="loadingSpinner" v-if="!loadEndFlag"><img src="@/assets/images/common/tail-spin.svg"></div>
      <template v-if="itemHistoryArr.length > 0 && loadEndFlag">
        <template v-if="readFirebaseItem == 'items'">
          <p class="no-data">商品は以上です</p>
        </template>
        <template v-else>
          <p class="no-data">仕入れは以上です</p>
        </template>
      </template>
      <template v-if="itemHistoryArr.length === 0 && loadEndFlag">
        <p class="no-data">データが見つかりませんでした</p>
      </template>

      <!-- 無限スクロール（商品表示）の判定DOM -->
      <infinite-loading @infinite="infiniteHandlerItem" spinner="spiral">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
      <!-- 無限スクロール（ページ）の判定DOM -->
      <infinite-loading @infinite="infiniteHandler" spinner="spiral">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>

      <!-- ポップアップでCSV出力情報の表示 -->
      <vs-popup fullscreen title="出力したいCSV情報を選択してください" :active.sync="popupActive">
        <!-- <div>
          <vs-chip
            :key="chip"
            @click="remove(chip)"
            v-for="chip in customCSVOption">
            {{ chip }}
          </vs-chip>
        </div> -->
        <vs-table
          stripe
          multiple
          v-model="selectedCSVItem" 
          :data="customCSVItem"
          class="csv-table">
          <template slot="thead">
            <vs-th v-for="itemHead in customCSVOption" :class="'th-'+decodeURIComponent(itemHead)">{{itemHead}}</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="td" v-for="(td, indextd) in tr">
                {{td}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-button class="btn-csvexport" v-bind:disabled="exportCSV" @click="csvExport()" type="filled">エクスポートする</vs-button>
      </vs-popup>

      <!-- ポップアップで商品情報の表示 -->
      <vs-popup fullscreen :title="selectItemTitle" :active.sync="popupItem" class="popup-item-detail">
        <vs-col vs-type="flex" vs-justify="between" class="tab-wrap ">
          <div v-if="selectItemTitle !== ''" class="tab-inner">
            <div class="tab-inner-inner flex-wrap">
              <vs-tabs alignment="fixed">
                <vs-tab label="仕入れ">
                  <div class="vx-row con-exemple-prompt input-prompt-wrap">
                    <div class="vx-col md:w-6/12 w-full">
                      <h5>出品登録</h5>
                      <div class="label-switch mt-4 mb-4">
                        <vs-switch v-model="prompt.stock.isfba"/><label for="" class="ml-2">FBA利用<template v-if="!prompt.stock.isfba">しない</template><template v-else>する</template></label>
                      </div>
                      <vs-input label="出品価格" type="number" v-model.number="prompt.stock.saleprice" class="input-number unit-input-yen"/>
                        <vs-input label="送料" type="number" v-model.number="prompt.stock.shipping" v-show="!prompt.stock.isfba" class="mt-3 input-number unit-input-yen"/>
                        <vs-input label="ポイント" type="number" v-model.number="prompt.stock.salepoint" class="mt-3 input-number"/>

                        <vs-input label="出品数" type="number" v-model.number="prompt.stock.salecount" class="mt-4 mb-3 input-number" value="1"/>

                        <label for="" class="vs-input--label mt-3">コンディション</label>
                        <v-select class="mt-1" v-model="prompt.stock.condition" :options="itemConditionLabel" /></v-select>

                        <vs-textarea label="コンディション説明を入力" class="mt-2" v-model="prompt.stock.conditionnote" />
                    </div>
                  </div>

                  <vs-divider />

                  <div class="text-center mt-4">
                    <vs-button type="filled"  class="ml-2 mr-2 mt-2" @click="saveExhibitData(selectItemAsin)">出品情報を保存する</vs-button>
                    <vs-button type="filled" color="warning" class="ml-2 mr-2 mt-2" @click="promptConfirmation(selectItemAsin)">この商品を出品登録する</vs-button>
                  </div>
                </vs-tab>
                <vs-tab label="新品">
                  <vs-table stripe :data="selectItemNew" noDataText="未設定">
                    <template slot="thead">
                      <vs-th>出品</vs-th>
                      <vs-th>送料</vs-th>
                      <vs-th>発送</vs-th>
                    </template>
                    <template slot-scope="{data}" >
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].exhibit" class="text-right">
                          {{Math.round(data[indextr].exhibit).toLocaleString()}}<span class="unit">円</span>
                        </vs-td>
                        <vs-td :data="data[indextr].postage" class="text-right">
                          {{Math.round(data[indextr].postage).toLocaleString()}}<span class="unit">円</span>
                        </vs-td>
                        <vs-td :data="data[indextr].shipping" class="shipping">
                          <vs-chip v-if="data[indextr].shipping != 'FBA'">{{data[indextr].shipping}}</vs-chip>
                          <vs-chip color="dark" v-else>{{data[indextr].shipping}}</vs-chip>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-tab>
                <vs-tab label="中古">
                  <vs-table stripe :data="selectItemUsed" noDataText="未設定">
                    <template slot="thead">
                      <vs-th>出品</vs-th>
                      <vs-th>送料</vs-th>
                      <vs-th>発送</vs-th>
                    </template>
                    <template slot-scope="{data}" >
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].exhibit" class="text-right">
                          {{Math.round(data[indextr].exhibit).toLocaleString()}}<span class="unit">円</span>
                        </vs-td>
                        <vs-td :data="data[indextr].postage" class="text-right">
                          {{Math.round(data[indextr].postage).toLocaleString()}}<span class="unit">円</span>
                        </vs-td>
                        <vs-td :data="data[indextr].shipping" class="shipping">
                          <vs-chip v-if="data[indextr].shipping != 'FBA'">{{data[indextr].shipping}}</vs-chip>
                          <vs-chip color="dark" v-if="data[indextr].shipping == 'FBA'">{{data[indextr].shipping}}</vs-chip>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
          <template v-else>
            <div class="notice-wrap">
              <p class="text-center">仕入れ情報、新品・中古の各価格を<br>見たい商品を選択してください</p>
            </div>
          </template>
        </vs-col>
      </vs-popup>
      
     <!-- ポップアップで入力したstock情報の確認 -->
     <vs-prompt
      @accept="itemExhibit"
      color="warning"
      accept-text="出品する"
      cancel-text="キャンセル"
      title="出品情報を確認"
      :active.sync="popupPrompt">
        <div class="confirm-wrap">
          <dl>
            <dt>FBA利用</dt>
            <dd v-if="prompt.stock.isfba">FBAを利用する</dd>
            <dd v-else>FBAを利用しない</dd>
          </dl>
          <dl>
            <dt>出品価格</dt>
            <dd class="unit-yen">{{prompt.stock.saleprice.toLocaleString()}}</dd>
          </dl>
          <dl>
            <dt>送料</dt>
            <dd class="unit-yen">{{prompt.stock.shipping.toLocaleString()}}</dd>
          </dl>
          <dl>
            <dt>ポイント</dt>
            <dd class="text-right">{{prompt.stock.salepoint}}</dd>
          </dl>
          <dl>
            <dt>出品数</dt>
            <dd class="text-right">{{prompt.stock.salecount}}</dd>
          </dl>
          <dl>
            <dt>コンディション</dt>
            <dd>{{prompt.stock.condition.label}}</dd>
          </dl>
          <dl>
            <dt>コンディション説明</dt>
            <dd>{{prompt.stock.conditionnote}}</dd>
          </dl>
          <p class="mt-6 ml-1 ml-1">※出品処理がセラーセントラルに反映されるまでに時間がかかります</p>
        </div>
      </vs-prompt>
    </template>
    

    <!-- ポップアップでグラフの表示 -->
    <vs-popup fullscreen :title="selectItemTitle" :active.sync="popupItemGraph" class="popup-item-detail popup-item-graph">
      <!-- グラフに表示した商品の情報 -->
      <div class="item-deteil">
        <vx-card class="list-view-item overflow-hidden graph-item-detail">
          <div class="vx-row item-details no-gutter ">
            <div class="vx-col vx-row item-details-container">
              <!-- IMG COL -->
              <div class="vx-col w-3/12 item-img-container bg-white flex items-center justify-center flex-wrap">
                <img :src="graphItemDetail.thumb" :alt="graphItemDetail.title" class="grid-view-img p-4 w-full">
                <!-- <div class="w-full text-center" v-if="typeof graphItemDetail.ranking !== 'undefined'">
                  <template v-if="graphItemDetail.ranking > 0">{{graphItemDetail.ranking}}</template>位
                </div> -->
              </div>
              <!-- ITEM NAME & DESC COL -->
              <div class="vx-col w-9/12 item-detail-container">
                <div class="detail-container">
                  <!--
                  <slot name="item-meta">
                    <div class="clearfix">
                      <vs-chip color="primary" v-if="graphItemDetail.cat !== ''">{{graphItemDetail.cat}}</vs-chip>
                    </div>
                    <h6 class="item-name font-semibold mt-2 mb-1">{{graphItemDetail.title}}</h6>
                    <p class="item-asin text-sm mb-2">
                      <template v-if="graphItemDetail.jan !== '' && graphItemDetail.asin !== graphItemDetail.jan"><img src="@/assets/images/logo/icon_barcode.png" class="icon">{{graphItemDetail.jan}} / </template>
                      <template v-if="graphItemDetail.asin !== ''">ASIN: {{graphItemDetail.asin}}</template>
                    </p>
                    <div class="star-wrap mb-2" v-if="graphItemDetail.rating > 0">
                      <star-rating :show-rating="false" :rating="graphItemDetail.rating" :star-size="20" read-only />
                      <span class="number">({{graphItemDetail.rating}})</span>
                    </div>
                    <p class="item-description text-sm" v-if="graphItemDetail.price > 0">参考価格: {{graphItemDetail.price.toLocaleString()}}円</p>
                  </slot>
                  -->
                  <h6 class="item-name font-semibold">{{graphItemDetail.title}}</h6>
                  <table class="itemSpecTable">
                    <tbody>
                      <tr>
                        <th>カテゴリー</th>
                        <td>
                          <template v-if="typeof graphItemDetail.cat !== 'undefined'">{{graphItemDetail.cat}}</template>
                          <template v-else>-</template>
                        </td>
                        <th>発売日</th>
                        <td>
                          <template v-if="typeof graphItemDetail.releaseDate !== 'undefined' && graphItemDetail.releaseDate != -1">{{graphItemDetail.releaseDate.toString().slice(0,4) + '/' + graphItemDetail.releaseDate.toString().slice(4,6) + '/' + graphItemDetail.releaseDate.toString().slice(6)}}</template>
                          <template v-else>-</template>
                        </td>
                      </tr>
                      <tr>
                        <th>ASIN</th>
                        <td>
                          <template v-if="typeof graphItemDetail.asin !== 'undefined'">{{graphItemDetail.asin}}</template>
                          <template v-else>-</template>
                        </td>
                        <th>JAN</th>
                        <td>
                          <template v-if="typeof graphItemDetail.jan !== 'undefined' && graphItemDetail.asin !== graphItemDetail.jan"><!-- <img src="@/assets/images/logo/icon_barcode.png" class="icon"> -->{{graphItemDetail.jan}}</template>
                          <template v-else>-</template>
                        </td>
                      </tr>
                      <tr>
                        <th>1ヶ月の販売数</th>
                        <td>
                          <template v-if="typeof graphItemDetail.salesRankDrops30 !== 'undefined' && graphItemDetail.salesRankDrops30 > 0">{{graphItemDetail.salesRankDrops30.toLocaleString()}}</template>
                          <template v-else>-</template>
                        </td>
                        <th>参考価格</th>
                        <td>
                          <template v-if="typeof graphItemDetail.price !== 'undefined' && graphItemDetail.price > 0">{{graphItemDetail.price.toLocaleString()}} 円</template>
                          <template v-else>-</template>
                        </td>
                      </tr>
                      <tr>
                        <th>ランキング</th>
                        <td>
                          <template v-if="typeof graphItemDetail.ranking !== 'undefined'">
                            <template v-if="graphItemDetail.ranking > 0">{{graphItemDetail.ranking}}</template> 位
                          </template>
                          <template v-else>-</template>
                        </td>
                        <th>評価</th>
                        <td>
                          <template v-if="typeof graphItemDetail.rating !== 'undefined'">
                            <div class="star-wrap" v-if="graphItemDetail.rating > 0">
                              <star-rating :show-rating="false" :rating="graphItemDetail.rating" :star-size="20" read-only />
                              <span class="number" v-if="graphItemDetail.review != 0">（{{graphItemDetail.review}}）</span>
                            </div>
                          </template>
                          <template v-else>-</template>
                        </td>
                      </tr>
                      <tr>
                        
                        <th>サイズ合計<br>(奥行 × 幅 × 高)</th>
                        <td>
                          <template v-if="typeof graphItemDetail.packageLength !== 'undefined' && typeof graphItemDetail.packageWidth !== 'undefined' && typeof graphItemDetail.packageHeight !== 'undefined'">
                          {{graphItemDetail.packageLength + graphItemDetail.packageWidth + graphItemDetail.packageHeight}} mm<br>
                          <span class="nowrap">( {{graphItemDetail.packageLength}} × {{graphItemDetail.packageWidth}} × {{graphItemDetail.packageHeight}} )</span></template>
                          <template v-else>-</template>
                        </td>
                        <th>重さ</th>
                        <td>
                          <template v-if="typeof graphItemDetail.packageWeight !== 'undefined'">{{graphItemDetail.packageWeight.toLocaleString()}} g</template>
                          <template v-else>-</template>
                        </td>
                        
                      </tr>
                    </tbody>
                  </table>
                  <div class=" mt-5">
                    <vs-button color="primary" type="filled" class="icon-btn small-btn" target :href='"https://www.amazon.co.jp/o/ASIN/"+graphItemDetail.asin+"/amacode-22"' v-if="graphItemDetail.asin !== ''">Amazon&nbsp;<feather-icon class="ml-2 icon size-s" icon="ExternalLinkIcon" /></vs-button>
                    <template v-if="graphItemDetail.variation != undefined">
                      <vs-button color="success" type="filled" class="icon-btn small-btn" target :href='"/search?son=1&s=" + graphItemDetail.variation.join()' v-if="graphItemDetail.variation.length > 0">{{graphItemDetail.variation.length}}件のバリエーション&nbsp;<feather-icon class="ml-2 icon size-s" icon="ExternalLinkIcon" /></vs-button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <vs-divider />

      <div class="vx-row text-center price-wrap">
        <div class="vx-col w-1/3 price-item">
          <h4 class="w-full price">
            <template v-if="graphItemDetail.cartPrice > 0">
              {{Math.round(graphItemDetail.cartPrice).toLocaleString()}}
              <span class="unit">円</span>
            </template>
            <template v-else>---</template>
          </h4>
          <div class="mt-1 ttl">カート</div>
        </div>
        <div class="vx-col w-1/3 price-item">
          <h4 class="w-full price">
            <template v-if="graphItemDetail.newPrice > 0">
              {{Math.round(graphItemDetail.newPrice).toLocaleString()}}<span class="unit">円</span>
            </template>
            <template v-else>---</template>
          </h4>
          <div class="mt-1 ttl" >
            新品<span v-if="graphItemDetail.newCount > 0">({{graphItemDetail.newCount}}件)</span>
            <template v-if="graphItemDetail.isNewPrime"><div class="chip-wrap"><vs-chip color="dark">F</vs-chip></div></template>
          </div>
        </div>
        <div class="vx-col w-1/3 price-item">
          <h4 class="w-full price">
            <template v-if="graphItemDetail.usedPrice > 0">
              {{Math.round(graphItemDetail.usedPrice).toLocaleString()}}<span class="unit">円</span>
            </template>
            <template v-else>---</template>
          </h4>
          <div class="mt-1 ttl">
            中古<span v-if="graphItemDetail.usedCount > 0">({{graphItemDetail.usedCount}}件)</span>
            <template v-if="graphItemDetail.isUsedPrime"><div class="chip-wrap"><vs-chip color="dark">F</vs-chip></div></template>
          </div>
        </div>
      </div>
      <!--
      <table stripe class="vs-table vs-table--tbody-table mt-3">
        <tbody>
          <tr v-if="graphItemDetail.fbaFeePrice !== 'undefined'" class="tr-values vs-table--tr tr-table-state-null selected">
            <th colspan="1" rowspan="1" class="text-center">
              <div class="vs-table-text font-bold">FBA手数料</div>
            </th>
            <td class="td vs-table--td text-right">{{Math.round(graphItemDetail.fbaFeePrice).toLocaleString()}}<span class="unit">円</span></td>
          </tr>
          
          <tr v-if="graphItemDetail.bepPrice !== 'undefined'" class="tr-values vs-table--tr tr-table-state-null selected">
            <th colspan="1" rowspan="1" class="text-center">
              <div class="vs-table-text font-bold">損益分岐（新品）</div>
            </th>
            <td class="td vs-table--td text-right">{{Math.round(graphItemDetail.bepPrice).toLocaleString()}}<span class="unit">円</span></td>
          </tr>
          
        </tbody>
      </table>
      -->

      <vs-divider />


      <div class="graph-btn-wrap">
        <div class="date-btn">
          <template v-for="dateButton in graphDateButton" :item="dateButton">
            <vs-button class="small-btn" @click="graphVisible(dateButton.num,chartVisivle)" v-bind:disabled="graphDefaultDate === dateButton.num">{{dateButton.name}}</vs-button>
          </template>
        </div>
        <div class="all-btn">
          <!-- <vs-button class="small-btn btn-all" @click="graphVisible(graphDefaultDate,0), toggleClass('1')" v-bind:class="{ 'is-active' : showButton.indexOf('1') >= 0 }" v-bind:disabled="chartVisivle === 0">すべて</vs-button> -->
          <vs-button class="small-btn btn-all" @click="graphVisible(graphDefaultDate,0)" v-bind:disabled="chartVisivle === 0">すべて</vs-button>
          <vs-button class="small-btn btn-new" @click="graphVisible(graphDefaultDate,1)" v-bind:disabled="chartVisivle === 1">新品</vs-button>
          <vs-button class="small-btn btn-use" @click="graphVisible(graphDefaultDate,2)" v-bind:disabled="chartVisivle === 2">中古</vs-button>
        </div>
        
      </div>
      <div class="graph-btn-category" :class='`color--${chartVisivle}`'>
        <template v-for="chartbtnWrap in visibleGraph[chartVisivle]" :item="chartbtnWrap">
          <template v-for="chartbtn in chartIndex" :item="chartbtn">
            <vs-button class="small-btn" type="filled" @click="graphButtonSwitchFlag(chartbtn.catname)" v-if="chartbtn.catname !== 'ranking' && chartbtnWrap.indexOf(chartbtn.catname) >= 0" v-bind:class="[{ 'is-active' : visibleGraphArr[chartVisivle].indexOf(chartbtn.catname) >= 0 },chartbtn.catname]" >{{chartbtn.name}}</vs-button>
          </template>
        </template>
      </div>
      <!-- グラフ -->

      <div id="chartWrap">
        <div v-if="!optionsList.length">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="84px" height="84px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
          <path d="M20 50A30 30 0 0 0 80 50A30 31.1 0 0 1 20 50" fill="#7366f0" stroke="none">
            <animateTransform attributeName="transform" type="rotate" dur="0.5464480874316939s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50.55;360 50 50.55"></animateTransform>
          </path></svg>
        </div>
        <highcharts
          v-else
          v-for="options in optionsList"
          :options="options"
          ref="highcharts"
          class="chart"
        ></highcharts>
      </div>

      <vs-divider />

      <!-- グラフ詳細データ -->
      <div id="graphData" class="table-graph">
        <vs-table :data="graphData">
          <template slot="thead">
            <vs-th class="text-center date">取得日</vs-th>
            <vs-th class="text-center ranking color_rank">ランキング</vs-th>
            <vs-th class="text-center sprice_n"><span class="color_new">新品</span>最安値</vs-th>
            <vs-th class="text-center count_new"><span class="color_new">新品</span>出品者数</vs-th>
            <vs-th class="text-center sprice_u"><span class="color_used">中古</span>最安値</vs-th>
            <vs-th class="text-center count_used"><span class="color_used">中古</span>出品者数</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="td-check" v-if="!tr.datecollect">&nbsp;</vs-td>
              <vs-td :data="tr.date" class="date">{{ tr.date }}時</vs-td>
              <vs-td :data="tr.ranking" class="ranking color_rank" :class="{'emphasis rank' : tr.ranking_flag}">
                <span v-if="tr.ranking !== ''">{{ tr.ranking }} 位</span>
                <span v-else >---</span>
              </vs-td>
              <vs-td :data="tr.sprice_n" class="sprice_n color_new">
                <span v-if="tr.sprice_n !== ''">{{ tr.sprice_n.toLocaleString() }} 円</span>
                <span v-else >---</span>
              </vs-td>
              <vs-td :data="tr.count_new" class="count_new color_newcount" :class="{'emphasis newcount' : tr.count_new_flag}">
                <span v-if="tr.count_new !== ''">{{ tr.count_new }} 件</span>
                <span v-else >---</span>
              </vs-td>
              <vs-td :data="tr.sprice_u" class="sprice_u color_used">
                <span v-if="tr.sprice_u !== ''">{{ tr.sprice_u.toLocaleString() }} 円</span>
                <span v-else >---</span>
              </vs-td>
              <vs-td :data="tr.count_used" class="count_used color_usedcount" :class="{'emphasis usedcount' : tr.count_used_flag}">
                <span v-if="tr.count_used !== ''">{{ tr.count_used }} 件</span>
                <span v-else >---</span>
              </vs-td>

              <template class="expand-user" slot="expand" v-if="tr.datecollect">
                <table class="vs-table vs-table--tbody-table">
                  <thead class="vs-table--thead">
                    <tr>
                      <th class="td-check">&nbsp;</th>
                      <th class="date">取得日</th>
                      <th class="ranking color_rank">ランキング</th>
                      <th class="sprice_n"><span class="color_new">新品</span>最安値</th>
                      <th class="count_new"><span class="color_newcount">新品</span>出品数</th>
                      <th class="sprice_u"><span class="color_used">中古</span>最安値</th>
                      <th class="count_used"><span class="color_usedcount">中古</span>出品数</th>
                    </tr>
                  </thead>
                  <tr class="" v-for="item in tr.datecollect" :item="item">
                    <td class="td-check">&nbsp;</td>
                    <td class="td vs-table--td date">{{item.date}}時</td>
                    <td class="td vs-table--td ranking color_rank" :class="{'emphasis rank' : item.ranking_flag}">
                      <span v-if="tr.ranking !== ''">{{item.ranking}} 位</span>
                      <span v-else >---</span>
                    </td>
                    <td class="td vs-table--td sprice_n color_new">
                      <span v-if="tr.sprice_n !== ''">{{item.sprice_n.toLocaleString()}} 円</span>
                      <span v-else >---</span>
                    </td>
                    <td class="td vs-table--td count_new color_newcount" :class="{'emphasis newcount' : item.count_new_flag}">
                      <span v-if="tr.count_new !== ''">{{item.count_new}} 件</span>
                      <span v-else >---</span>
                    </td>
                    <td class="td vs-table--td sprice_u color_used">
                      <span v-if="tr.sprice_u !== ''">{{item.sprice_u.toLocaleString()}} 円</span>
                      <span v-else >---</span>
                    </td>
                    <td class="td vs-table--td count_used color_usedcount" :class="{'emphasis usedcount' : item.count_used_flag}">
                      <span v-if="tr.count_used !== ''">{{item.count_used}} 件</span>
                      <span v-else >---</span>
                    </td>
                  </tr>
                </table>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-popup>


    <!-- バーコード読み取り -->
    <div id="cameraWrap" v-bind:class="{ 'is-active' : scanOn }">
      <div class="cameraWrapInner">
        <div class="cameraAreaWrap">
          <div class="cameraAreaWrapInner">
            <div id="cameraArea">
                <img v-if="code.length" src="" alt="" class="resultImg" id="resultImg" />
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block; shape-rendering: auto;" width="84px" height="84px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                  <path d="M20 50A30 30 0 0 0 80 50A30 31.1 0 0 1 20 50" fill="#fff" stroke="none">
                    <animateTransform attributeName="transform" type="rotate" dur="0.5464480874316939s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50.55;360 50 50.55"></animateTransform>
                  </path>
                </svg>
              </div>
              <p class="catch">カメラにバーコードをかざして<br>検索をクリック</p>
            </div>
          </div>
        
          <!-- <p v-if="code.length" class="getMessage">取得できました</p> -->
          <!-- <p class="resultCode">{{ code }}</p> -->
          <!-- <button @click="startScanBarcode">Scan</button> -->
          <!-- <button aria-label="close" class="btn-close" @click.prevent.stop="stopScan"><feather-icon icon="XIcon" /></button> -->
          <div class="button">
            <vs-button color="danger" type="filled" @click="stopScan()">キャンセル</vs-button>
            <vs-button color="primary" type="filled" @click="searchCall(); stopScan()">検索する</vs-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import vSelect from 'vue-select'
import StarRating from 'vue-star-rating'
import InfiniteLoading from 'vue-infinite-loading'
import firebase from 'firebase/app'
import 'firebase/functions'
import 'firebase/remote-config'
import moment from 'moment'
import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
am4core.useTheme(am4themes_animated);

import {Chart} from 'highcharts-vue'
import validbarcode from 'barcode-validator'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BButton, BRow, BCol, BCardText,
} from 'bootstrap-vue'

import axios from 'axios'
import jsonp from 'jsonp'

import barcoder from 'barcoder'
import ISBN from 'isbn-validate'

export default {
  props: {
    // searchページの詳細検索
    search_detail_flag: Boolean
  },
  data () {
    return{
      searchError: [],
      searchCategory :[],
      searchForm: { // 詳細検索用
        word: '',                       // キーワード
        category: {},                   // カテゴリ情報
        is_Amazon_outOfStock: false,    // Amazon在庫を除外
        current_SALES_gte : null,       // ランキング 以上
        current_SALES_lte : null,       // ランキング 以内
        current_NEW_gte : null,         // 新品価格(円) 以上
        current_NEW_lte  : null,        // 新品価格(円) 以下
        deltaPercent90_NEW_gte : null,  // 新品 90日間の値下り / 値上り率(%) 以上
        deltaPercent90_NEW_lte : null,  // 新品 90日間の値下り / 値上り率(%) 以下
        current_COUNT_NEW_gte : null,   // 新品出品者数 以上
        current_COUNT_NEW_lte  : null,  // 新品出品者数 以下
        is_New_outOfStock: false,       // 新品在庫なし
        current_USED_gte : null,        // 中古価格(円) 以上
        current_USED_lte : null,        // 中古価格(円) 以下
        deltaPercent90_USED_gte : null, // 中古 90日間の値下り / 値上り率(%) 以上
        deltaPercent90_USED_lte : null, // 中古 90日間の値下り / 値上り率(%) 以下
        current_COUNT_USED_gte : null,  // 中古出品者数 以上
        current_COUNT_USED_lte  : null, // 中古出品者数 以下
        is_Used_outOfStock: false,      // 中古在庫なし
        page: 0,
      },
      searchFormInit: {},
      loadFlag:false,
      Quagga: null,
      code: "",
      codeFlag: true,
      codeArr: [],
      routeTitle: this.$route.meta.pageTitle,
      readFirebaseItem: this.$route.meta.readFirebaseItem,
      itemHistory: {},        // firebaseから取得したuserのitem情報
      itemHistoryAsin: [],    // firebaseから取得したasinに基づく商品情報
      itemHistoryArr: [],     // 商品表示用配列
      itemHistoryArrAsin: [], // asin保存用配列
      selectItemTitle: '',    // 選択した商品のタイトル
      selectItemAsin: '',     // 選択した商品のasin
      selectItemStock: [],    // 選択した商品の仕入れ情報
      selectItemNew: [],      // 選択した商品の新品情報
      selectItemUsed: [],     // 選択した商品の中古情報
      infiniteHandlerItemState:'',
      infiniteHandlerItemPageState:'',
      itemRequestTotal: 10,  // アイテムの取得件数
      itemRequest: 5,        // 1回の読み込みで表示する商品数
      itemRequestCount: 0,    // 読み込みをした商品数
      itemRequestCountCheck: 0,// 前回読み込みをした商品数
      itemDisplayCount: 0,    // 商品を表示したカウント
      itemDisplayCountTotal: 0,// 表示する商品数
      itemFirstCount: 0,      // 1回目の読み込みの商品をカウントする（初期時のみ使用）
      itemFirstCountCheck: 0, // 1回目の読み込みの商品をカウントし終わったかどうか（初期時のみ使用）
      itemLast: '',           // 最後に読み込んだ商品のasin
      itemLastTimestamp: '',  // 最後に読み込んだ商品のtimestamp
      infiniteCount: 1,       // 無限スクロールをした回数
      logdingFlag: true,      // 無限スクロールをするかどうかのフラグ
      loadingItemFlag: true,  // 無限スクロール（取得済みの商品表示）をするかどうかのフラグ
      itemWord: '商品履歴',
      customOption: [],       // カスタムオプション（ボタン）の設定データ
      customSkuOption: [],    // カスタムSKUの設定データ
      customSku: '',          // カスタムSKUの元の文字列
      customSkuDefault: '{datetime}-{condition_id}-{stock_price}-{list_price}', // カスタムSKUのデフォルト設定
      popupActive: false,     // CSVデータを表示するポップアップの表示フラグ
      popupItem: false,       // アイテムの詳細を表示するポップアップの表示フラグ
      selectedCSVItem:[],     // CSVを出力するデータ
      //exportCSV: false,       // CSVを出力するボタンのdisabled設定
      customCSVOption: [],    // カスタムCSVの設定データ
      customCSVLoad: true,    // CSVデータ（仕入れデータ）の初回読み込みフラグ
      customCSVdata: [],      // 取得したCSVデータ
      customCSVItem: [],      // 形成したCSVデータを格納する
      csvDefault: {
        'name':'商品名',
        'asin':'ASIN',
        'jan':'JAN/EAN',
        'cat':'カテゴリー',
        'cat_name':'カテゴリー名',
        'rank':'ランキング',
        'cart':'カート',
        'cart2':'カート（手数料引き）',
        'new':'新品',
        'new2':'新品（手数料引き）',
        'used':'中古',
        'used2':'中古（手数料引き）',
        'star':'評価',
        'rating':'評価数',
        'price':'参考価格',
        'list_price':'出品価格',
        'shipping_price':'配送料',
        'stock_price':'仕入れ価格',
        'stock':'仕入れ数',
        'gross':'粗利益',
        'condition_id':'コンディションID',
        'date':'日付',
        'datetime':'日付時間',
        'timestamp':'タイムスタンプ',
        'sku':'sku',
        'condition':'状態',
        'condition_note':'コンディション説明',
        'part_number':'製造番号',
        'model':'型番',
        'note':'ノート'
      },
      popupItemGraph: false,  // グラフ用ポップアップ表示フラグ
      graphDefaultDate: 30,   // グラフの初期読み込み日数
      graphData: [],          // グラフのデータを挿入
      graphItemDetail: {},
      chart: '',              // グラフ変数
      chartIndex: [],         // 各グラフのindexを挿入
      chartVisivle: 0,        // グラフの新品・中古表示フラグ、trueなら新品表示。falseなら中古表示
      visibleGraph: [         // 表示したいグラフの一覧
        [ // すべて
          'sprice_n',
          'sprice_u',
          'count_new',
          'count_used',
          'ranking'
        ],
        [ // 新品
          'sprice_n',
          'newlist',
          'amazon',
          'fbalist',
          'fmblist',
          'listprice',
          'count_new',
          'ranking'
        ],
        [ // 中古
          'sprice_u',
          'usedlist',
          'usedVeryGoodlist',
          'usedLikeNewlist',
          'usedGoodlist',
          'usedAcceptablelist',
          'count_used',
          'ranking'
        ],
      ],
      visibleGraphArr: [],     // グラフボタン表示
      searchArr: [],           // キーワードで検索した商品挿入
      searchArrSave: [],       // 商品一時保存用
      searchArrNg: [],
      searchDetail: '',        // 検索中の状態文言
      searchApiInterval: 1200, // 検索APIのリクエスト間隔
      //popupStockInput: false,// stock情報の入力
      popupPrompt:false,       // 
      itemConditionLabel:[     // コンディション情報
        {label: '新品', id:11, value:1},
        {label: '中古(ほぼ新品)', id:1, value:2},
        {label: '中古(非常に良い)', id:2, value:3},
        {label: '中古(良い)', id:3, value:4},
        {label: '中古(可)', id:4, value:5},
        {label: 'コレクター(ほぼ新品)', id:5, value:6},
        {label: 'コレクター(非常に良い)', id:6, value:7},
        {label: 'コレクター(良い)', id:7, value:8},
        {label: 'コレクター(可)', id:8, value:9},
        {label: '再生品', id:9, value:10},
      ],
      prompt:{                 // 出品情報
        asin: '',
        asstype: 0,
        sku: '',
        timestamp: '',
        stock: {
          AmazonPay: 0,
          arariprice: 0,
          condition: {label: '新品', id:11, value:1},
          conditionnote: '',
          fbasendpay: 0,
          isfba: false,
          otherpay: 0,
          salecount: 1,
          salepoint: 0,
          saleprice: 0,
          shipping: 0,
          stockdatetime: '',
          stocknote: '',
          stockprice: 0,
          storagePay: 0,
          weightPay: 0,
          workPay: 0
        }
      },
      promptInit: {},          // 出品情報初期化用変数
      promptFlag: false,       // 出品可能フラグ
      optionsList: [],         // 表示させるチャートデータのリスト
      itemResultData: [],      // 商品詳細の解析データ（365日分）
      showButton: [],           // タブボタンのactive判定
      chartOption:{             // チャートデータの子オプション
        name:['価格','出品者数','ランキング'],
        catname:[
          [
            'sprice_n',  // 新品最安値
            'sprice_u',  // 中古最安値
            'amazon',    // アマゾン本体
            'fbalist',   // FBA
            'fmblist',   // 自己発送
            'listprice', // カート
            'newlist',   // 新品
            'usedVeryGoodlist',// ほぼ新品
            'usedLikeNewlist',// 非常に良い
            'usedGoodlist',// 良い
            'usedAcceptablelist',// 可
            'usedlist'   // 中古
          ],
          [
            'count_used', // 中古 出品者数
            'count_new', // 新品 出品者数
          ],
          ['ranking']    // ランキング
        ],
        sub:[
          [
            '新品最安値',   // sprice_n
            '中古最安値',   // sprice_u
            'Amazon本体',  // amazon
            'FBA',        // fbalist
            '自己発送',    // fmblist
            'カート',      // listprice
            '新品価格',    // newlist
            'ほぼ新品',    // usedVeryGoodlist
            '非常に良い',  // usedLikeNewlist
            '良い',       // usedGoodlist
            '可',         // usedAcceptablelist
            '中古価格'      // usedlist
          ],
          [
            '中古出品者数', // count_used
            '新品出品者数', // count_new
          ],
          ['ランキング']
        ],
        type:['line','area','line'],
        color:[
          [
            '#7366f0', // 新品最安値 // 元の色：23b701
            '#000000', // 中古最安値 // 元の色：f3bf30
            '#ff9f43', // アマゾン本体（プライム？）// 0695ff
            '#ff8dcc', // FBA
            '#696969', // 自己発送 // 元の色：000000
            '#91d7ff', // カート　#4f38ff
            '#26AE90', // 新品価格 #02ded6
            '#f74747', // ほぼ新品
            '#ff8dcc', // 非常に良い
            '#91d7ff', // 良い
            '#f3bf30', // 可 // 元の色:000000
            '#ff8400'  // 中古価格 #f3bf30
          ],
          [
            '#d8d7d7',  // 中古 出品者数 // 元の色：ff9e43
            '#648cff', // 新品 出品者数 // 元の色：29c76f
          ],
          [
            '#29c76f'  // ランキング // 元の色：7366f0
          ]
        ],
        unit:['円','件','位']
      },
      graphDateButton: [        // グラフの期間表示ボタン
        {name:"1週間",num:7},
        {name:"1ヶ月",num:30},
        {name:"2ヶ月",num:60},
        {name:"3ヶ月",num:90},
        {name:"12ヶ月",num:365},
      ],
      scanOn: false,            // バーコードスキャン表示・非表示
      searchCatSelect: [],      // 詳細検索パラメータ
      searchDetailDisplay: false, // 詳細検索フォーム表示・非表示
      searchWord: '',           // 検索ワード
      suggestArr: [],           // サジェスト表示配列
      selectFlag: false,        // 
      suggestDisplay: false,    // 
      searchAsinArr: [],        // 詳細検索時のasin保存配列
      searchTotalResults: "-",  // 検索時のトータル件数
      searchCategoryRemove: [   // カテゴリの排除用関数
        "jp-spine",
        "jp-stores",
        "Kindleストア",
        "Prime Video",
      ],
      searchItemCount: 15,      // 検索結果表示件数
      searchItemTotal: 100,     // 検索結果取得件数
      searchItemNow: 0,         // 現在の表示件数
      searchItemNextCount: 0,　// 次の表示件数
      searchItemNextTotal: 100, // 次の検索結果取得件数
      loadEndFlag: false,       // 検索を終了させる
      searchInfiniteFlag: false,  // 待機時間
      searchDelayFlag: true,     // 検索時の入力猶予用フラグ
      searchAwateFlag: true,    // 最終検索時のawaitフラグ
      searchMode: false,        // 検索モードtrueならasin（コード）検索、falseならワード検索
      loadingEndFlag: false,    // 完全に読み込みが終了フラグ
    }
  },
  components: {
    StarRating,
    InfiniteLoading,
    vSelect,
    highcharts: Chart,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BButton,
    BRow,
    BCol,
    BCardText,
  },
  computed: {
    exportCSV () {
      return this.selectedCSVItem.length > 0 ? false : true
    },
    searchText: {
      get () {
        //this.suggestDisplay = false
        //this.suggestArr = []
        this.suggestWord(this.searchForm.word)
        return this.searchForm.word
      },
      set (value) {
        this.searchError = []
        this.searchForm.word = value
      }
    }
  },
  watch: {
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
      this.readFirebaseItem = this.$route.meta.readFirebaseItem
    }
  },
  methods: {
    // ■ 初期読み込み
    // userのitems内のAsin情報を取得し、最新のAsinデータを取得する
    getItemHistory() {
      // 【ユーザー階層】ドメイン / users / UUID / 〇〇
      // 【商品履歴】ドメイン / users / UUID / items（挿入されているのはAsinのの番号）
      // 【仕入れ】ドメイン / users / UUID / stocks

      if (this.readFirebaseItem === 'search') {
        this.itemHistoryAsin = []
        return
      }

      this.loadFlag = false
      this.logdingFlag = false

      // get firebase current user
      const firebaseCurrentUser = firebase.auth().currentUser
      const self = this // スコープを通す

      if (firebaseCurrentUser == null) { return }

      // ----- 商品情報の取得 -----
      const dbUserItemsRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/' + this.readFirebaseItem)
      
      // 初回読み込みの初期化
      //this.itemFirstCount = this.itemRequest
      this.itemFirstCount = this.itemRequest

      // 初回の読み込み
      // dbUserItemsRef.limitToFirst(this.itemRequest).once('value', function(snapshot) {
      dbUserItemsRef.limitToFirst(this.itemRequestTotal * this.infiniteCount).once('value', function(snapshot) {
        self.$vs.loading.close()

        self.loadFlag = true;
        // 初回に読み込む商品が存在しない場合
        if (snapshot.val() === null) {
          self.logdingFlag = false
          self.addAfterFlag = true
          self.loadingItemFlag = false
          self.loadEndFlag = true
          return
        }

        // 読み込み時に商品数が読み込み設定より少なければ、
        // 無限スクロールのロードフラグをオフ、商品の追加位置をを逆にする
        if (Object.keys(snapshot.val()).length < self.itemRequest) {
          self.logdingFlag = false
          self.addAfterFlag = true
          self.loadingItemFlag = false
          self.loadEndFlag = true
          //self.logdingFlag = false
          return
        } else {
          //self.logdingFlag = true
          self.addAfterFlag = false
        }
        // 初回の読み込みしたリスト数を挿入
        //self.itemFirstCount = Object.keys(snapshot.val()).length
        // 読み込んだリストの最後の値を挿入
        self.itemLast = Object.keys(snapshot.val())[Object.keys(snapshot.val()).length - 1]
        self.itemLastTimestamp = snapshot.val()[self.itemLast].timestamp

        // 初回読み込み時のローディング表示を閉じる
        //self.$vs.loading.close()
        
        // 読み込み完了通知読み込みが
        /*
        self.$vs.notify({
          title:'読み込みが完了しました',
          text:'',
          color:'primary',
          icon:'check'
        })
        */
      }, function(errorObject) {
      })

      // 商品を取得もしくは追加されたときにフック
      //dbUserItemsRef.limitToFirst(this.itemRequest).on('child_added', function(snapshot) {
      dbUserItemsRef.limitToFirst(this.itemRequestTotal * this.infiniteCount).on('child_added', function(snapshot) {

        // ユーザーの商品保存情報を保存
        var snapshotInsert = snapshot.val()
        snapshotInsert.displayId = self.itemRequestCount
        self.itemHistory[snapshot.key] = snapshotInsert

        // 商品読み込み数をカウントアップ
        self.itemRequestCount++
        self.itemDisplayCountTotal++

        const dbAsinRef = firebase.database().ref('items/' + snapshot.key)
        let addAfterFlag = false

        // 配列へ追加する箇所を変更するフラグのチェック
        if (self.itemFirstCount !== self.itemFirstCountCheck) {
          self.itemFirstCountCheck++
        } else {
          addAfterFlag = true
        }

        dbAsinRef.on('value', function(snapshot02) {
          // 読み込んだリストのAsinを代入
          //self.itemLast = snapshot02.val().asin

          // 粗利を挿入する
          var insert = snapshot02.val()

          //if (snapshot02.val() === null) { return }
          if (typeof self.itemHistory[snapshot.key].stock !== 'undefined') {
            insert.arariprice = self.itemHistory[snapshot.key].stock.arariprice
          } else {
            insert.arariprice = ''
          }

          // 初回の商品追加の前後方向をフラグでチェック
          if(addAfterFlag) {
            //self.itemHistoryAsin.unshift(insert)
            //self.itemHistoryArr.unshift(insert)
            
            self.itemHistoryAsin.push(insert)
            //self.itemHistoryArrAsin.push(insert.asin)
            /*
            self.$vs.notify({
              title:'商品が追加されました',
              text:insert.name,
              color:'success',
              icon:'check'
            })
            */
            //self.itemDisplayCount++
          } else {
            self.itemHistoryAsin.push(insert)
            self.itemHistoryArr.push(insert)
            self.itemHistoryArrAsin.push(insert.asin)
            self.itemDisplayCount++
          }
          
          
        }, function(errorObject) {
        })
      })

      // 商品が削除されたときにフック
      // firebaseでのデータ削除を検知し、対象の配列を削除
      dbUserItemsRef.on('child_removed', function(snapshot) {
        var deletedPost = snapshot.val();
        const index = self.itemHistoryAsin.findIndex((v) => v.asin === deletedPost.asin)
        // 取得している商品の配列から対象の商品を削除
        self.itemHistoryAsin.splice(index, 1)
        self.$vs.notify({
          title: '商品が削除されました',
          text: deletedPost.name,
          color: 'danger',
          icon: 'trash'
        })
      })

      // 商品が変更されたときにフック
      dbUserItemsRef.on('child_changed', function(snapshot) {
        var changedPost = snapshot.val();
        
        // 商品情報を更新（displayIdを付与）
        var itemHistoryInsert = changedPost
        itemHistoryInsert.displayId = self.itemHistory[changedPost.asin].displayId
        self.itemHistory[changedPost.asin] = itemHistoryInsert

        // 商品表示配列の対象の商品情報を更新（araripriceを付与）
        if (typeof itemHistoryInsert.stock !== 'undefined') {
          let displayId = itemHistoryInsert.displayId
          // 指定IDとasinで商品の整合性チェック
          if (self.itemHistoryAsin[displayId].asin !== changedPost.asin) {
            for (let i = 0; self.itemHistoryAsin.length > i; i++) {
              if (self.itemHistoryAsin[i].asin === changedPost.asin){
                displayId = i
              }
            }
          }

          self.itemHistoryAsin[displayId].arariprice = itemHistoryInsert.stock.arariprice

          // もし現在表示状態であれば、現在の値を更新する
          if (changedPost.asin === self.selectItemAsin) {
            self.dataVisible(self.itemHistoryAsin[displayId])
          }

          self.$vs.notify({
            title:'仕入れ商品の情報が変更されました',
            text: changedPost.name,
            color:'warning',
            icon:'check'
          })
        }
      })
    },
    // ■ 無限スクロール
    infiniteHandlerItem($state) {
      // stateを変数へ挿入
      this.infiniteHandlerItemState = $state

      if(!this.loadingItemFlag){ return }
      //this.loadingItemFlag = false
      
      let self = this
      if (this.itemHistoryArr.length >= this.itemRequestTotal * this.infiniteCount - 1) {
        this.logdingFlag = true
        this.loadingItemFlag = false
        return
      } else {
        // 指定した件数ごとに表示
        /*
        for (var i = 0; this.itemRequest > i; i++) {
          if (!this.itemHistoryAsin[this.itemDisplayCount]){
            if (this.itemHistoryArrAsin.indexOf(this.itemHistoryAsin[this.itemDisplayCount].asin) === -1) {
              
            } else {
            }
          }  
        }
        */
        
        for (var i = 0; this.itemHistoryAsin.length > i;i++) {
          if (this.itemHistoryArrAsin.indexOf(this.itemHistoryAsin[i].asin) == -1) {
            this.itemHistoryArr.push(this.itemHistoryAsin[i])
            this.itemHistoryArrAsin.push(this.itemHistoryAsin[i].asin)
            this.itemDisplayCount++
          }
        }
      }
      if (self.loadEndFlag){
        $state.complete()
      }
      
      // 連続でローディングすることを防ぐ
      // ＊＊＊ 2回目のここがおかしい？ ＊＊＊
      setTimeout( function(){
        // 表示用配列のほうが小さかった場合、商品を読み込む
        if (self.itemHistoryArr.length >= self.itemRequestTotal * self.infiniteCount) {
          self.loadingItemFlag = false
          self.logdingFlag = true
          if(typeof self.infiniteHandlerItemPageState != 'undefined' && self.infiniteHandlerItemPageState != null && self.infiniteHandlerItemPageState != ''){
            self.infiniteHandlerItemPageState.loaded()
          }
        } else {
          self.loadingItemFlag = true
          self.logdingFlag = false
        }
      }, 500 )
      $state.loaded()
    },
    // ■ 無限スクロール（データベースからデータを取得）
    infiniteHandler($state) {
      // stateを変数へ挿入
      this.infiniteHandlerItemPageState = $state

      // 無限スクロールの読み込みフラグがfalseであれば処理を終了
      if(!this.logdingFlag){ return }

      // 一旦、無限スクロールを停止
      //this.logdingFlag = false
      //this.loadingItemFlag = false

      this.startScrollYOffset = window.innerHeight + window.pageYOffset

      const firebaseCurrentUser = firebase.auth().currentUser
      const dbUserItemsRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/' + this.readFirebaseItem)
      const self = this

      // 読み込み回数を1プラス
      this.infiniteCount++
      this.$vs.loading()

      // 最後に読み込んだ商品から読み込みたい個数先の商品asinを読み込む
      //dbUserItemsRef.orderByChild('timestamp').endAt(self.itemLastTimestamp).limitToLast(this.itemRequest + 1).once('value', function(snapshot01) {
      // タイムスタンプ順で　、　
      //dbUserItemsRef.orderByChild('timestamp').endAt(self.itemLastTimestamp).limitToLast(this.itemRequest + 1).once('value', function(snapshot01) {
      
      dbUserItemsRef.limitToFirst(this.itemRequestTotal * this.infiniteCount).once('value', function(snapshot01) {
      //dbUserItemsRef.endAt(self.itemLastTimestamp).limitToFirst(this.itemRequest + self.itemRequestCount).once('value', function(snapshot01) {

        // 前回のカウント数を挿入する
        self.itemRequestCountCheck = self.itemRequestCount
        let counter = 0

        // 読み込みする商品がない場合
        /*
        if (snapshot01.val() == null) {
          self.logdingFlag = false
          $state.complete()
          self.$vs.loading.close()
          return
        }
        */

        let itemCounter = 0
        // 対象商品を総合asinから照合してaddする
        for (let key in snapshot01.val()) {
          // 取得した商品が配列にない場合addする
          if (self.itemHistoryArrAsin.indexOf(key) == -1) {
            // ユーザーの商品保存情報を保存
            var snapshotInsert = snapshot01.val()[key]
            snapshotInsert.displayId = self.itemRequestCount + counter
            counter = counter + 1 // id用のカウントをアップ
            self.itemHistory[key] = snapshotInsert

            const dbAsinRef = firebase.database().ref('items/' + key)
            dbAsinRef.once('value', function(snapshot02) {
              // 粗利を挿入する
              var insert = snapshot02.val()

              if (typeof self.itemHistory[key].stock !== 'undefined') {
                insert.arariprice = self.itemHistory[key].stock.arariprice
              } else {
                insert.arariprice = ''
              }
              // 商品表示配列へadd
              self.itemHistoryAsin.push(insert)
              // 商品読み込み数をカウントアップ
              self.itemRequestCount++
              self.itemDisplayCountTotal++
              // 前回読み込んだ数値と設定した商品読み込み数を足した数値（現在読み込むべき商品数）と、
              // 現在まで読み込んだ商品数を比較して同一であれば無限スクロールのロードフラグをオンにする
              /*
              if ((self.itemRequestCountCheck + self.itemRequest) === self.itemRequestCount) {
                $state.loaded()
              }
              */
              // すべてのarrayへAdd終了後（配列の長さをチェック）に下のロジックを入れてローディングをオンにする


            }, function(errorObject) {
            })
          }

          itemCounter++

          if (Object.keys(snapshot01.val()).length == itemCounter) {
            setTimeout( function(){
              if (Object.keys(snapshot01.val()).length < self.itemRequestTotal * self.infiniteCount) {
                self.loadEndFlag = true
                self.logdingFlag = true
                self.loadingItemFlag = true
                self.infiniteHandlerItemState.loaded()
                $state.complete()
              } else {
                self.loadEndFlag = false
                self.logdingFlag = false
                self.loadingItemFlag = true
                self.infiniteHandlerItemState.loaded()
                $state.loaded()
              }
              self.$vs.loading.close()
            }, 500 )
          }
        }



        // asinを代入
        /*
        self.itemLast = Object.keys(snapshot01.val())[Object.keys(snapshot01.val()).length - 1]
        self.itemLastTimestamp = snapshot01.val()[self.itemLast].timestamp

        if(self.itemLastTimestamp === 'undefined'){
          self.logdingFlag = true
          self.loadingItemFlag = true
        }
        */

        // 返り値をチェックして5以下であればストップそれ以外であればinfinite scrollを再開させる
        /*
        if (Object.keys(snapshot01.val()).length < self.itemRequestTotal * self.infiniteCount) {
          self.loadEndFlag = true
        } else {
          self.loadingItemFlag = true
          self.loadEndFlag = false
          $state.loaded()
        }
        */
      })

      
    },
    // ■ 商品をクリックした際に右カラムへ仕入れ・新品・中古の情報を表示する
    dataVisible (item) {

      this.popupItem = true
      this.selectItemTitle = ''
      this.selectItemAsin = ''
      this.selectItemStock = []
      this.selectItemNew = []
      this.selectItemUsed = []

      let asin = item.asin
      let counterStock = 0
      let counterNew = 0
      let counterUsed = 0

      this.selectItemAsin = item.asin

      // 商品の出品情報を整理
      this.itemExhibitInput(item.asin)

      for (var i = 0; this.itemHistoryAsin.length > i; i++) {
        if(this.itemHistoryAsin[i].asin == asin) {
          let itemData = this.itemHistoryAsin[i]

          this.selectItemTitle = itemData.name

          // 仕入れ価格をユーザーの設定から取得する
          const firebaseCurrentUser = firebase.auth().currentUser
          const dbUserItemsRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/' + this.readFirebaseItem)
          const self = this

          // ユーザーの対象商品の保存情報を代入
          if(typeof this.itemHistory[asin].stock !== 'undefined') {
            this.selectItemStock = this.itemHistory[asin].stock
          } else {
            this.selectItemStock = ''
          }

          if(typeof itemData.low !== 'undefined') {
            // 商品の新品と中古の価格を変数へ代入する
            for (var j = 0; itemData.low.LowestOfferListing.length > j; j++) {
              if (itemData.low.LowestOfferListing[j].Qualifiers.ItemCondition === 'New') {
                // 新品
                let shipping = 'FBA'
                if (itemData.low.LowestOfferListing[j].Qualifiers.FulfillmentChannel !== 'Amazon') {
                  shipping = '自己発送'
                }
                this.selectItemNew.push({
                  "id": counterNew,
                  "exhibit": itemData.low.LowestOfferListing[j].Price.ListingPrice.Amount,
                  "postage": itemData.low.LowestOfferListing[j].Price.Shipping.Amount,
                  "shipping": shipping
                })
                counterNew++
              } else {
                // 中古
                let shipping = 'FBA'
                if (itemData.low.LowestOfferListing[j].Qualifiers.FulfillmentChannel !== 'Amazon') {
                  shipping = '自己発送'
                }
                this.selectItemUsed.push({
                  "id": counterUsed,
                  "exhibit": itemData.low.LowestOfferListing[j].Price.ListingPrice.Amount,
                  "postage": itemData.low.LowestOfferListing[j].Price.Shipping.Amount,
                  "shipping": shipping
                })
                counterUsed++
              }
            }
          }
          break
        }
      }
    },
    // ■ 価格出力時に新品の最初の要素を取得する
    getPriceFirst (item, cond) {
      let price = 0
      let condition = 'New'
      let result = {
        'price': price,
        'shipping': '自己発送'
      }
      // lowの存在チェック
      if(typeof item.low === 'undefined') { return result }

      // 状態の更新 true：New、false：Used
      if (!cond) {
        condition = 'Used'
      }

      if(item.low.LowestOfferListing.length > 0) {
        for (var i = 0; item.low.LowestOfferListing.length > i; i++) {
          if(item.low.LowestOfferListing[i].Qualifiers.ItemCondition === condition){
            result.price = item.low.LowestOfferListing[i].Price.LandedPrice.Amount
            if(item.low.LowestOfferListing[i].Qualifiers.FulfillmentChannel === 'Amazon'){
              result.shipping = 'FBA'
            }
            break
          }
        }  
      } else {
        if(item.low.LowestOfferListing.Qualifiers.ItemCondition === condition){
          result.price = item.low.LowestOfferListing.Price.LandedPrice.Amount
          if(item.low.LowestOfferListing.Qualifiers.FulfillmentChannel === 'Amazon'){
            result.shipping = 'FBA'
          }
        }
      }


      return result
    },
    // ■ 商品の状態（新品 or 中古）の個数を取得
    getItemCount (item,cond) {
      var condition = 'New'
      var result = 0
      if (!cond) {
        condition = 'Used'
      }

      if (typeof item.cart !== 'undefined'){
        for (var i = 0; item.cart.NumberOfOfferListings.OfferListingCount.length > i; i++) {
          if (item.cart.NumberOfOfferListings.OfferListingCount[i]['@condition'] === condition) {
            result = item.cart.NumberOfOfferListings.OfferListingCount[i]['text']
          }
        }
      }
      return result
    },
    // ■ firebaseから仕入れ情報を取得してCSVとしてエクスポートする
    csvSurfaceVisible () {
      var self = this
      this.popupActive = true

      this.selectedCSVItem = []
      this.customCSVdata = this.itemHistory
      
      this.csvFormation()
    },
    // ■ 選択したアイテムをエクスポートする
    csvExport () {
      let line = '\ufeff' + this.customCSVOption.join() + '\n'
      // forで各値を挿入する
      for (let i = 0; this.selectedCSVItem.length > i; i++) {
        for (let j = 0; this.customCSVOption.length > j; j++) {
          if(this.selectedCSVItem[i][this.customCSVOption[j]] !== 'undefined') {
            line = line + decodeURIComponent(this.selectedCSVItem[i][this.customCSVOption[j]])
          }
          if (this.customCSVOption.length - 1 === j) {
            line = line + '\n'
          } else {
            line = line + ','
          }
        }
      }
      
      let blob = new Blob([line], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      const date1 = new Date();
      const date2 = date1.getFullYear() + '-' + 
            (date1.getMonth() + 1)  + '-' + 
            date1.getDate() + '_' + 
            date1.getHours() + '_' + 
            date1.getMinutes() + '.csv'
      link.download = date2
      link.click()
      
      this.$vs.notify({
        title:'エクスポートが完了しました',
        text:'',
        color:'success',
        icon:'check'
      })
    },
    // ■ CSV表示用データを形成する
    csvFormation () {
      // this.customCSVdata // 取得した仕入れデータ
      // this.customCSVItem // 取得した仕入れデータを表示用に形成したデータ
      // this.customCSVOption // CSVの表示設定データ
      this.customCSVItem = []
      let self = this
      let count = 0
      for (let key in this.customCSVdata) {
        let format = {}
        const dbAsinRef = firebase.database().ref('items/' + key)
        dbAsinRef.on('value', function(snapshot) {
          let csvValue = self.customFormation(key, self.customCSVdata[key], snapshot.val())
          for (let i = 0; self.customCSVOption.length > i; i++) {
            if (typeof csvValue[self.customCSVOption[i]] !== 'undefined') {
              format[self.customCSVOption[i]] = csvValue[self.customCSVOption[i]]
            } else {
              format[self.customCSVOption[i]] = ''
            }
          }
          self.customCSVItem.push(format)
        }, function(errorObject) {
        })

        count++
      }
      

    },
    // ■ カスタムオプションボタンのアクション。作成したURLを返却。
    customButtonUrl (option,asin) {
      let url = ''
      switch (option.key){
        case 'amazon':
          url = 'https://www.amazon.co.jp/o/ASIN/' + asin + '/amacode-22'
          break
        case 'denno':
          url = 'https://denno-s.com/?code=' + asin
          break
        case 'kakakucom':
          url = 'https://amacode.app/kakakucom.php?keyword=' + option.name
          break
        case 'aucfun':
          url = 'https://amacode.app/aucfan-web.php?keyword=' + option.name
          break
          /*
        case 'origin':
          url = this.customOptionConversion(option.contentBody,asin)
          break
          */
        default:
          url = this.customOptionConversion(option.contentBody,asin)
          break
      }
      //return url
      window.open(url, '_blank', 'noreferrer')
    },
    // ■ カスタムオプションボタンのアクション。メールを作成する。
    customButtonMail(title,content,asin) {
      let mailto = "mailto:"
      let mailTitle = ''
      let mailContent = ''
      if (typeof title !== 'undefined' || title !== '') {
        mailTitle = this.customOptionConversion(title,asin)
        mailTitle = '?subject=' + encodeURIComponent(mailTitle.replace(/,/g, ''))
      }
      if (typeof content !== 'undefined' || content !== '') {
        mailContent = this.customOptionConversion(content,asin)
        mailContent = '&body=' + encodeURIComponent(mailContent.replace(/,/g, ''))
      }
      mailto = mailto + mailTitle + mailContent
      //return mailto
      window.open(mailto, '_blank')
    },
    // ■ カスタムオプションボタンのアクション。クリップボードコピー。
    clipCopy(content,asin) {
      const copy = this.customOptionConversion(content,asin)
      const self = this
      this.$copyText(copy).then(function (e) {
          self.$vs.notify({
            title:'クリップボードへコピーしました',
            text:e.text,
            color:'success',
            icon:'check'
          })
      }, function (e) {
          self.$vs.notify({
            title:'クリップボードへのコピーが失敗しました',
            text:e.text,
            color:'success',
            icon:'check'
          })
      })
    },
    // ■ オプションで使用されている{}内の文字列を解析・置換し、URLを生成して返却する
    customOptionConversion(url,asinCode) {
      let conversion = url
      let baseItemValue = ''

      if(this.readFirebaseItem != 'search'){
        
        baseItemValue = this.customFormation(asinCode,this.itemHistory[asinCode],this.itemHistoryAsin[this.itemHistory[asinCode].displayId])
      } else {
        var item = "";
        for (var i = 0;this.searchArr.length > i;i++) {
          if(this.searchArr[i].asin == asinCode){
            item = this.searchArr[i];
            break;
          }
        }
        
        baseItemValue = this.customFormation(asinCode,item,item)
      }

      let matches = this.paramAnalysis(conversion)

      // 一致する文字列を置換の対象として、その中の文字を元に対象の値を抽出して置換文字に当てはめる
      for (var i = 0; matches.length > i; i++) {
        conversion = conversion.replace('{' + matches[i] + '}', baseItemValue[matches[i]])
      }

    
      return conversion
    },
    // ■ 引数のasinに該当する各データを返却する
    customFormation(asinCode,userValue,item) {
      let userAsinValue = userValue
      let itemValue = item
      let baseItemValue = {}

      // itemの数値がない場合空のObjectをreturn
      /*
      if (typeof itemValue === 'undefined') {
        return baseItemValue
      }
      */
      // asin
      if (typeof userValue.asin !== 'undefined') {
        baseItemValue.asin = userValue.asin
      } else {
        baseItemValue.asin = asinCode
      }
      // jan
      if (typeof itemValue.jan !== 'undefined') {
        baseItemValue.jan = itemValue.jan
      } else {
        if (typeof itemValue.code !== 'undefined') {
          baseItemValue.jan = itemValue.code
        } else {
          baseItemValue.jan = ''
        }
      }
      // cat name
      if (typeof userAsinValue.cat !== 'undefined') {
        baseItemValue.cat = userAsinValue.cat.replace(/\s+/g, '')
      } else {
        baseItemValue.cat = ''
      }
      // ランキング
      if (typeof itemValue !== 'undefined' && typeof itemValue.info !== 'undefined' && typeof itemValue.info.SalesRankings !== 'undefined') {
        if (itemValue.info.SalesRankings.SalesRank.length > 0) {
          baseItemValue.rank = itemValue.info.SalesRankings.SalesRank[0].Rank
        } else {
          baseItemValue.rank = itemValue.info.SalesRankings.SalesRank.Rank
        }
      } else {
        if (typeof itemValue !== 'undefined' && typeof itemValue.ranking !== 'undefined') {
          baseItemValue.rank = userAsinValue.ranking
        } else {
          baseItemValue.rank = ''
        }
      }

      // ns2（Model・PartNumber
      


      if (typeof itemValue !== 'undefined' && typeof itemValue.model !== 'undefined') {
        baseItemValue.model = itemValue.model
      } else if (typeof itemValue !== 'undefined' && typeof itemValue.info !== 'undefined' && typeof itemValue.info.AttributeSets !== 'undefined') {
        if (itemValue.info.AttributeSets["ns2:ItemAttributes"]) {
          if (itemValue.info.AttributeSets["ns2:ItemAttributes"]["ns2:Model"]) {
            baseItemValue.model = itemValue.info.AttributeSets["ns2:ItemAttributes"]["ns2:Model"]
          } else {
            baseItemValue.model = ''
          }
        }
      } else {
        baseItemValue.model = ''
      }

      if (typeof itemValue !== 'undefined' && typeof itemValue.part_number !== 'undefined') {
        baseItemValue.part_number = itemValue.part_number
      } else if (typeof itemValue !== 'undefined' && typeof itemValue.info !== 'undefined' && typeof itemValue.info.AttributeSets !== 'undefined') {
        if (itemValue.info.AttributeSets["ns2:ItemAttributes"]) {
          if (itemValue.info.AttributeSets["ns2:ItemAttributes"]["ns2:PartNumber"]) {
            baseItemValue.part_number = itemValue.info.AttributeSets["ns2:ItemAttributes"]["ns2:PartNumber"]
          } else {
            baseItemValue.part_number = ''
          }
        }
      } else {
        baseItemValue.part_number = ''
      }


      // 商品名
      if (typeof itemValue !== 'undefined' && typeof itemValue.name !== 'undefined') {
        baseItemValue.name = this.htmlspecialchars(itemValue.name)
      } else if (typeof itemValue !== 'undefined' && typeof itemValue.title !== 'undefined') {
        baseItemValue.name = itemValue.title
      } else if (typeof userValue.name !== 'undefined'){
        baseItemValue.name = userValue.name
      } else {
        baseItemValue.name = ''
      }

       
      // カテゴリ名
      if (typeof itemValue !== 'undefined' && typeof itemValue.catName !== 'undefined') {
        baseItemValue.cat_name = itemValue.catName
      } else if (typeof userValue.catName !== 'undefined'){
        baseItemValue.cat_name = userValue.catName
      } else {
        baseItemValue.cat_name = ''
      }
      // 評価
      if(typeof userAsinValue.reviewStart !== 'undefined') {
        baseItemValue.star = userAsinValue.reviewStart
      } else {
        if (typeof itemValue !== 'undefined' && typeof itemValue.rating !== 'undefined') {
          baseItemValue.star = itemValue.rating
        } else {
          baseItemValue.star = 0
        }
      }
      // 評価数
      if(typeof userAsinValue.reviewCount !== 'undefined') {
        baseItemValue.rating = userAsinValue.reviewCount
      } else {
        if (typeof itemValue !== 'undefined' && typeof itemValue.review !== 'undefined') {
          baseItemValue.rating = itemValue.review
        } else {
          baseItemValue.rating = 0
        }
      }
      // カート
      if(typeof itemValue !== 'undefined' && typeof itemValue.cart !== 'undefined' && typeof itemValue.cart.CompetitivePrices !== 'undefined') {
        baseItemValue.cart = Math.round(itemValue.cart.CompetitivePrices.CompetitivePrice.Price.LandedPrice.Amount)
      } else {
        if(typeof itemValue !== 'undefined' && typeof itemValue.cartPrice !== 'undefined') {
          baseItemValue.cart =  userAsinValue.cartPrice
        } else {
          baseItemValue.cart =  0  
        }
        
      }
      // 新品
      let newPrice = 0
      if (typeof itemValue !== 'undefined') {
        if(typeof itemValue.newPrice === 'undefined') {
          newPrice = Math.round(this.getPriceFirst(itemValue, true).price)
        } else {
            newPrice = itemValue.newPrice
        }
      }
      baseItemValue.new = newPrice

      // 中古
      let usedPrice = 0
      if (typeof itemValue !== 'undefined') {
        if(typeof itemValue.usedPrice === 'undefined') {
          usedPrice = Math.round(this.getPriceFirst(itemValue, false).price)
        } else {
          usedPrice = itemValue.usedPrice
        }
      }
      baseItemValue.used = usedPrice
      
      // 参考価格
      if(typeof userAsinValue.price !== 'undefined') {
        baseItemValue.price = userAsinValue.price
      } else {
        baseItemValue.price = 0
      }
      // ユーザー仕入れデータ
      if(typeof userAsinValue.stock !== 'undefined') {
        if (typeof userAsinValue.stock.saleprice !== 'undefined') {
          baseItemValue.list_price = userAsinValue.stock.saleprice
        } else {
          baseItemValue.list_price = 0
        }
        if (typeof userAsinValue.stock.shipping !== 'undefined') {
          baseItemValue.shipping_price = userAsinValue.stock.shipping
        } else {
          baseItemValue.shipping_price = 0
        }
        if (typeof userAsinValue.stock.stockprice !== 'undefined') {
          baseItemValue.stock_price = userAsinValue.stock.stockprice
        } else {
          baseItemValue.stock_price = 0
        }
        if (typeof userAsinValue.stock.salecount !== 'undefined') {
          baseItemValue.stock = userAsinValue.stock.salecount
        } else {
          baseItemValue.stock = 0
        }
        if (typeof userAsinValue.stock.arariprice !== 'undefined') {
          baseItemValue.gross = userAsinValue.stock.arariprice
        } else {
          baseItemValue.gross = 0
        }
        //moment(date * 1000).format('YYYY/MM/DD');
        //itemValue.date = userAsinValue.stock.stockdatetime // 変換（20200707）
        if (typeof userAsinValue.stock.stockdatetime !== 'undefined') {
          baseItemValue.date = moment(userAsinValue.stock.stockdatetime * 1000).format('YYYYMMDD') // 変換（20200707）
          //itemValue.datetime = userAsinValue.stock.stockdatetime // 変換（20200707095009）
          baseItemValue.datetime = moment(userAsinValue.stock.stockdatetime * 1000).format('YYYYMMDDHHmmss') // 変換（20200707095009）
          baseItemValue.timestamp = userAsinValue.stock.stockdatetime
        } else {
          baseItemValue.date = moment().format('YYYYMMDD')
          baseItemValue.datetime = moment().format('YYYYMMDDHHmmss')
          baseItemValue.timestamp = moment().unix()
        }
        if (typeof userAsinValue.stock.conditionnote !== 'undefined') {
          baseItemValue.condition_note = encodeURIComponent(userAsinValue.stock.conditionnote.replace(/,/g, ''))
        } else {
          baseItemValue.condition_note = ''
        }
        if (typeof userAsinValue.stock.stocknote !== 'undefined') {
          baseItemValue.note = encodeURIComponent(userAsinValue.stock.stocknote.replace(/,/g, ''))
        } else {
          baseItemValue.note = ''
        }
        // 状態
        if (typeof userAsinValue.stock.condition !== 'undefined') {
          const getCond = this.conditionCheck(userAsinValue.stock.condition)
          baseItemValue.condition = getCond.name
          baseItemValue.condition_id = getCond.id
          //'condition_id' : ,
        } else {
          baseItemValue.condition = ''
          baseItemValue.condition_id = 11
        }
      } else {
        baseItemValue.list_price = 0
        baseItemValue.shipping_price = 0
        baseItemValue.stock_price = 0
        baseItemValue.stock = 0
        baseItemValue.gross = 0
        baseItemValue.date = moment().format('YYYYMMDD')
        baseItemValue.datetime = moment().format('YYYYMMDDHHmmss')
        baseItemValue.timestamp = moment().unix()
        baseItemValue.condition_note = ''
        baseItemValue.note = ''
        baseItemValue.condition = ''
        baseItemValue.condition_id = 11
      }
      //'sku' : , // ユーザー設定を取得して対象の値を割り当てる（users/UID/settings/）

      // new2
      if (typeof userAsinValue.sortLowNewPrice !== 'undefined') {
        baseItemValue.new2 = userAsinValue.sortLowNewPrice
      } else {
        baseItemValue.new2 = 0
      }
      // used2
      if (typeof userAsinValue.sortLowUsedPrice !== 'undefined') {
        baseItemValue.used2 = userAsinValue.sortLowUsedPrice
      } else {
        baseItemValue.used2 = 0
      }
      // cart2
      if (typeof userAsinValue.sortCartPrice !== 'undefined') {
        baseItemValue.cart2 = userAsinValue.sortCartPrice
      } else {
        baseItemValue.cart2 = 0
      }

      baseItemValue.sku = this.skuFormation(baseItemValue)

      return baseItemValue
    },
    // ■ htmlspecialcharsをしてreturnする
    htmlspecialchars(str){
      return (str + '').replace(/&/g,'&amp;')
                   .replace(/"/g,'&quot;')
                   .replace(/'/g,'&#039;')
                   .replace(/</g,'&lt;')
                   .replace(/>/g,'&gt;'); 
    },
    // ■ skuを形成して返却する
    skuFormation (itemValue) {
      let conversion = this.customSku

      // 一致する文字列を置換の対象として、その中の文字を元に対象の値を抽出して置換文字に当てはめる
      for (var i = 0; this.customSkuOption.length > i; i++) {
        conversion = conversion.replace('{' + this.customSkuOption[i] + '}', itemValue[this.customSkuOption[i]])
      }
      return conversion
    },
    // ■ 「{}」で囲われた文字列を抽出し、配列として返却する
    paramAnalysis (param) {
      //const regexp = new RegExp('(?<={).*?(?=})','g')
      const regexp = new RegExp('{.*?}','g')
      let match
      let matcharr = []
      let analysis = []
      let analysis_save = []
      let self = this
      // 正規表現で一致する文字を抽出する
      match = param.match(regexp)
      // 正規表現で取り切れなかった{}を削除（safari対策）
      let cont = 0
      if (match === null) { return analysis }
      match.forEach(function(item) {
        matcharr.push(item.replace('}', ''))
        matcharr[cont] = matcharr[cont].replace('{', '')
        cont++
      })
      // nullチェック
      if (matcharr === null) { return analysis }
      matcharr.forEach(function(item) {
        // デフォルトの配列とマッチした場合と現在の配列に同じ文字が含まれていない場合は配列へadd
        if (self.csvDefault[item] && analysis_save.indexOf(item) === -1) {
          analysis_save.push(item)
        }
      })
      // 一致した配列を並び替え
      analysis_save.forEach(function(item) {
        if (self.csvDefault[item]) {
          analysis.push(item)
        }
      })
      return analysis
    },
    // ■ 商品の状態（コンディション）を数字で判断し返却する
    conditionCheck (condition) {
      let conditionResult = {
        name:'',
        id:0
      }
      switch (condition){
        case 1:
          conditionResult.name = '新品'
          conditionResult.id = 11
          break
        case 2:
          conditionResult.name = '中古(ほぼ新品)'
          conditionResult.id = 1
          break
        case 3:
          conditionResult.name = '中古(非常に良い)'
          conditionResult.id = 2
          break
        case 4:
          conditionResult.name = '中古(良い)'
          conditionResult.id = 3
          break
        case 5:
          conditionResult.name = '中古(可)'
          conditionResult.id = 4
          break
        case 6:
          conditionResult.name = 'コレクター(ほぼ新品)'
          conditionResult.id = 5
          break
        case 7:
          conditionResult.name = 'コレクター(非常に良い)'
          conditionResult.id = 6
          break
        case 8:
          conditionResult.name = 'コレクター(良い)'
          conditionResult.id = 7
          break
        case 9:
          conditionResult.name = 'コレクター(可)'
          conditionResult.id = 8
          break
        case 10:
          conditionResult.name = '再生品'
          conditionResult.id = 9
          break
        default :
          conditionResult.name = ''
          conditionResult.id = 0
          break
      }
      return conditionResult
    },
    // ■ アイテムのグラフデータを取得して表示する
    dataGraphVisible(asinCode) {
      this.selectItemTitle = ''
      this.graphItemDetail = {}
      const self = this
      // グラフボタン表示データの初期化
      this.visibleGraphArr = JSON.parse(JSON.stringify(this.visibleGraph))
      let removeArr = []
      const remove = ['sprice_n','sprice_u','ranking','count_new','count_used']
      //'sprice_n','sprice_u',
      for (var i = 0; this.chartOption.catname.length > i; i++) {
        for (var j = 0; this.chartOption.catname[i].length > j; j++) {
          removeArr.push(this.chartOption.catname[i][j])
        }
      }
      for (var i = 0; remove.length > i; i++) {
        var index = removeArr.indexOf(remove[i])
        if (index > -1) {
          removeArr.splice(index, 1)
        }
      }
      
      for (var i = 0; this.visibleGraphArr.length > i; i++) {
        for (var j = 0; removeArr.length > j; j++) {
          if (i == 0 && (removeArr[j] == 'count_new' || removeArr[j] == 'count_used')) { break }
          var index = this.visibleGraphArr[i].indexOf(removeArr[j])
          if (index > -1) {
            this.visibleGraphArr[i].splice(index, 1)
          }
        }
      }

      window.history.replaceState('','','?q='+asinCode)

      // グラフと表にローダーを表示
      this.$vs.loading()

      // ----- 下記グラフデータの生成 -----
      var getProductGrpah = firebase.functions().httpsCallable('getProductGrpah')
      getProductGrpah({asin: asinCode, stats : 365}).then(function(result) {
        if (result.data.result === 'ok') {
          // データを解析してグラフの表示をする
          self.dataGraphAnalysis(result)
        } else {
          self.$vs.loading.close()
          self.$vs.dialog({
            title: '商品が見つかりませんでした',
            text: '対象の商品が見つかりませんでした',
            acceptText: '閉じる'
          })
        }
      }).catch(function(error) {
        // Getting the Error details.
        var code = error.code
        var message = error.message
        var details = error.details
      })
    },
    // ■ グラフのデータを解析する
    dataGraphAnalysis(result) {
      const self = this
      // ポップアップの表示
      self.popupItemGraph = true
      // 製品データ表示
      self.graphItemDetail = result.data.product
      // 形成用データの保存
      let table_data_save = {}
      // 最終データ
      let table_data = []
      // 最終データを保存する
      self.itemResultData = []
      // keyの代入用
      let table_key = {}
      // 前回の値を代入
      let old_table_key = {}
      const today = moment().format('YYYY-MM-DD')

      // ■ 価格（新品）
      // newlist：新品の価格？
      // amazon：amazonの新品価格（プライム）
      // fbalist：fbaはプライムを利用した出品者価格（）
      // fmblist：fmbプライムじゃない自己発送価格（）
      // listprice：
      // ■ 価格（中古）
      // usedlist：中古の価格？
      // ■ ランキング
      // ranking：ランキングの数値
      // ■ 出品数
      // count_new：新品の出品数？
      // count_used：中古の出品数？

      // 各オブジェクトごとに日付を確認しながら値をaddする
      Object.entries(result.data.data).forEach(([key, value]) => {
        // 空判定
        if (Object.keys(value).length) {
          table_key[key] = null
          const date = value.xlabels
          for (var i = 0; date.length > i; i++) {
            if (!table_data_save[date[i]]) {
              table_data_save[date[i]] = {}
            }
            // 日付
            table_data_save[date[i]].date = moment(value.xlabels[i] * 1000).format('YYYY-MM-DD HH')
            //table_data_save[date[i]].datetime = moment.unix(value.xlabels[i])._d
            table_data_save[date[i]].datetime = moment.unix(value.xlabels[i])._i
            // それぞれの値
            if (!table_data_save[date[i]][key]) {
              table_data_save[date[i]][key] = value.ylabels[i]
            }
          }
        }
      })
      // 日付ごとの値チェック
      Object.entries(table_data_save).forEach(([key, value]) => {
        // 値の整合性を取る
        Object.entries(table_key).forEach(([key2, value2]) => {
          // keyが存在しない場合は「-」存在する場合は「前回挿入した値」
          if (!value[key2]) {
            // 「-」を代入
            table_data_save[key][key2] = table_key[key2]
          } else {
            table_key[key2] = table_data_save[key][key2]
          }
        })
        // 最小価格を抽出
        Object.entries(value).forEach(([key3, value3]) => {
          // 新品の値から最低値を抽出
          if (key3 === 'newlist' || key3 === 'amazon' || key3 === 'fbalist' || key3 === 'fmblist' || key3 === 'listprice') {
            // 値がない場合 or 現在挿入されている値が以前の値より小さい場合
            if (!table_data_save[key].sprice_n || table_data_save[key].sprice_n >= value3 && table_data_save[key].sprice_n === '') {
              table_data_save[key].sprice_n = value3
              old_table_key.sprice_n = value3
            }
          }
          // 中古の値から最低値を抽出
          if (key3 === 'usedlist' || key3 === 'usedVeryGoodlist' || key3 === 'usedLikeNewlist' || key3 === 'usedGoodlist' || key3 === 'usedAcceptablelist') {
            // 値がない場合 or 現在挿入されている値が以前の値より小さい場合
            if (!table_data_save[key].sprice_u || table_data_save[key].sprice_u >= value3 && table_data_save[key].sprice_u === '') {
              table_data_save[key].sprice_u = value3
              old_table_key.sprice_u = value3
            }
          }
        })

        // 前回の数値との比較をして前回より小さければフラグを立てる
        // 新品最低値のチェック
        if (old_table_key.sprice_n > value.sprice_n) {
          table_data_save[key].sprice_n_flag = true
        }
        old_table_key.sprice_n = value.sprice_n
        // 新品出品数のチェック
        if (old_table_key.count_new > value.count_new) {
          table_data_save[key].count_new_flag = true
        }
        old_table_key.count_new = value.count_new
        // 中古最低値のチェック
        if (old_table_key.sprice_u > value.sprice_u) {
          table_data_save[key].sprice_u_flag = true
        }
        old_table_key.sprice_u = value.sprice_u
        // 中古出品数のチェック
        if (old_table_key.count_used > value.count_used) {
          table_data_save[key].count_used_flag = true
        }
        old_table_key.count_used = value.count_used
        // ランキングのチェック
        if (old_table_key.ranking > value.ranking) {
          table_data_save[key].ranking_flag = true
        }
        old_table_key.ranking = value.ranking
        
        
        table_data.unshift(value)
      })
      // 最終的なデータをグローバル変数へ代入
      self.itemResultData = table_data
      this.graphVisible(this.graphDefaultDate,this.chartVisivle)
    },
    // ■ グラフを表示する（期間とカテゴリが含まれた配列番号を指定）
    graphVisible(statusNum,visibleNum) {
      this.graphDefaultDate = statusNum
      this.chartVisivle = visibleNum
      const self = this
      // データ挿入用
      let table_data = []
      // チャートデータの初期化
      self.optionsList = []
      // テーブル表示用データの初期化
      self.graphData = []
      // チャート全体のデータ
      let chartData = {}
      // チャート表示非表示ボタン用
      self.chartIndex = []

      // 指定された日付分のデータをaddする
      for (var j = 0; this.itemResultData.length > j; j++) {
        if (moment().diff(this.itemResultData[j].date.substr(0, 10), 'day') <= statusNum) {
          table_data.push(this.itemResultData[j])
        }
      }

      let count = 0
      // 日付をテーブル表示用にまとめる
      for (var i = 0; table_data.length > i; i++) {
        let graphItem = {}
        // 表の表示用にnullがエラーになるのでnullだった場合は空の文字列を挿入
        for (let key in table_data[i]) {
          if (table_data[i][key] === null) {
            graphItem[key] = ''
          } else {
            graphItem[key] = table_data[i][key]
          }
        }
        // 初期値の場合データを挿入
        if (self.graphData.length === 0) {
          self.graphData.push(graphItem)
        }
        // 日付を比較して同一の日付であれば同一日にまとめる
        if (self.graphData[count].date.substr(0, 10) === graphItem.date.substr(0, 10) && count > 0) {
          if (!self.graphData[count].datecollect) {
            self.graphData[count].datecollect = []
          }
          self.graphData[count].datecollect.push(graphItem)
        } else {
          self.graphData.push(graphItem)
          count++
        }
      }
      


      // チャート用のデータを形成（name,type,unitは共通の値）
      for (var t = 0; this.chartOption.name.length > t; t++) {

        // 各共通データを挿入
        let saveChartData = {
          name : this.chartOption.name[t],
          type : this.chartOption.type[t],
          unit : this.chartOption.unit[t],
          valueDecimals : 0,
          data : [],
          sub : [],
          catname: [],
          color : []
        }

        // table_dataから対象のデータを取得して形成する
        Object.entries(this.chartOption.catname[t]).forEach(([key2, value2],index2) => {
          // 指定したグラフはaddしない
          if (self.visibleGraph[visibleNum].indexOf(value2) === -1) { return }

          let save_catname = []
          for (var j = 0; table_data.length > j; j++) {
            save_catname.push([table_data[j].datetime, table_data[j][value2]])
          }
          saveChartData.catname.push(value2)
          saveChartData.data.push(save_catname)
          saveChartData.sub.push(self.chartOption.sub[t][index2])
          saveChartData.color.push(self.chartOption.color[t][index2])
          self.chartIndex.push({
            name:self.chartOption.sub[t][index2],
            catname:value2,
            color:self.chartOption.color[t][index2]
          })
        })
        // できたデータを大本の配列にaddする
        chartData[t] = saveChartData
      }

      // チャートの生成（※モーダルで表示するとカーソルがずれる不具合があるためsettimeoutでディレイをかけている）
      setTimeout( function(){
        self.$vs.loading.close()
        Object.entries(chartData).forEach(([key, value],index) => {
          self.optionsList.push(self.genOptions(self, value, visibleNum))
        })
      }, 800 )
    },
    // ■ チャートデータの作成
    genOptions(vm, dataset, visibleNum) {
      // ■ チャート生成時のイベント設定
      function sync(vm, event, type) {
        vm.$refs.highcharts.forEach(({ chart }) => {
          if (chart === this.series.chart) return;
          let tooltipArr = []
          let visibleArr = []
          for (var i = 0; chart.series.length > i; i++) {
            for (var j = 0; chart.series[i].data.length > j; j++){
              if (chart.series[i].data[j].x === this.x && chart.series[i].data[j].series.visible && chart.series[i].data[j].y !== null) {
                tooltipArr.push(chart.series[i].data[j])
                visibleArr.push(chart.series[i].data[j].series.userOptions.catname)
              }
            }
          }
          chart.series.forEach((series) => {
            if (visibleArr.indexOf(series.userOptions.catname) === -1) { return }
            series.data.forEach((point) => {
              if (point.x === this.x) {
                if (type === 'over') {
                  point.setState('hover');
                  chart.tooltip.refresh(tooltipArr);
                  chart.xAxis[0].drawCrosshair(event, point);
                } else {
                  point.setState();
                  chart.tooltip.hide();
                  chart.xAxis[0].hideCrosshair();
                }
              }
            });
          });
        });
      }


      let value = {
        chart: {
          marginLeft: 70,
          spacingTop: 20,
          spacingBottom: 0
        },
        title: {
          text: dataset.name,
          align: 'left',
          margin: 0,
          x: 0,
          y: 6,
          backgroundColor: null,
          borderWidth: 0,
          shadow: false,
          useHTML: true,
          style: {
              padding: 0
          },
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%m/%e}'
          },
          crosshair: {
            enabled: true,
            width: 1,
            color: '#ccc'
          }
        },
        yAxis: {
          title: {
            text: null
          },
          labels: {
            formatter: function() {
              let unit = ''
              if (dataset.name === '価格') {
                unit = '円'
              }
              if (this.value < 10000) {
                return this.chart.numberFormatter(this.value, 0, ',', ',') + unit
              } else {
                return (this.value / 10000).toFixed(1) + '万'
              }
            }
          }
        },
        tooltip: {
          animation: false,
          backgroundColor: null,
          borderWidth: 0,
          shadow: false,
          shared: true,
          crosshairs: true,
          useHTML: true,
          headerFormat: '<small class="tooltip-date">{point.key}</small><div class="tooltip-wrap">',
          pointFormat: '<div class="tooltip-inner"><div data-color="{series.color}" style="color:{series.color};" data-symbol="{series.symbol}" class="ttl"><span class="name">{series.name}</span></div>' +
              '<div class="value"><b>{point.y}</b></div></div>',
          footerFormat: '</div>',
          style: {
              padding: 0
          },
          xDateFormat: '<span class="date">%Y/%m/%d</span><span class="hour">%H時</span>',
          valueDecimals: dataset.valueDecimals
        },
        boost: {
          useGPUTranslations: true,
          usePreAllocated: true
        },
        plotOptions: {
          series: {
            turboThreshold: 100000,
            animation: false,
            point: {
              events: {
                mouseOver: function(event) {
                  sync.call(this, vm, event, 'over');
                },
                mouseOut: function(event) {
                  sync.call(this, vm, event, 'out');
                }
              }
            }
          },
          dataLabels: {
            formatter: function() {
              if (this.y != 0) {
                return this.y;
              }
            }
          }
        },
        series: []
      }

      // データが存在するかしないかのチェック
      let series_data = []
      let check_arr = []
      for (var i = 0; dataset.data.length > i; i++) {
        let visible = false
        /*
        // 初期時に指定のデータを表示する
        if (dataset.catname[i] == 'ranking' || dataset.catname[i] == 'count_new' || dataset.catname[i] == 'count_used' || dataset.catname[i] == 'sprice_n' || dataset.catname[i] == 'sprice_u') {
          visible = true
        }
        // ソートボタンの整合性を合わせる
        if (dataset.catname[i] == 'sprice_n' || dataset.catname[i] == 'sprice_u') {
          this.showButton.push(dataset.catname[i])
        }
        */
        if (this.visibleGraphArr[visibleNum].indexOf(dataset.catname[i]) >= 0) {
          visible = true
        }
        let savedata = {
          data: dataset.data[i],
          name: dataset.sub[i],
          catname: dataset.catname[i],
          type: dataset.type,
          color: dataset.color[i],
          fillOpacity: 0.7,
          lineWidth: 1,
          visible: visible,
          tooltip: {
            valueSuffix: ' ' + dataset.unit
          }
        }
        series_data.push(savedata)

        let check = dataset.data[i].map(function(value,index,array){
           return value[1]
        })
        check_arr = check_arr.concat(check)
      }
      value.series = series_data

      if (check_arr.every(v => v === null)) {
        value.subtitle = {
          text: 'データがありません',
          align: 'center',
          useHTML: true,
          x: 60,
          y: 40,
          style: {
            padding: 0
          }
        }
      }

      return value
    },
    // ■ グラフの状態を指定して対象のグラフを表示。それ以外を非表示にする。
    graphButtonSwitchFlag(name) {
      this.$refs.highcharts.forEach(({ chart }) => {
        chart.series.forEach((series) => {
          if (series.userOptions.catname === name) {
            if (series.userOptions.visible || typeof series.userOptions.visible === "undefined") {
              series.hide()
              var index = this.visibleGraphArr[this.chartVisivle].indexOf(name)
              if (index > -1) {
                this.visibleGraphArr[this.chartVisivle].splice(index, 1)
              }
            } else {
              series.show()
              this.visibleGraphArr[this.chartVisivle].push(name)
            }
          }
        })
      })
    },
    // ■ 指定したグラフの表示・非表示を切り替える
    graphSwitch(chart) {
      if (chart.isHiding || chart.isHidden) {
        chart.show();
      }
      else {
        chart.hide();
      }
    },
    // ■ getパラメータを解析して返却する
    getparamAnalysis(params) {
      let param = ''
      if (params !== null && typeof params !== 'undefined' && params !== '') {
        param = this.$route.query[params]
      } else {
        param = this.$route.query
      }
      
      return param
    },
    // ■ 設定の初期化
    settingInit() {
      // prompt初期化用変数に初期の値を挿入
      this.promptInit = JSON.parse(JSON.stringify(this.prompt))
      this.searchFormInit = JSON.parse(JSON.stringify(this.searchForm))

      // get firebase current user
      const firebaseCurrentUser = firebase.auth().currentUser
      const self = this // スコープを通す

      if (firebaseCurrentUser == null) { return }

      // ----- カスタムボタン設定 -----
      const dbUserCustomOptionRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/options')
      // カスタムボタン設定の初期呼び出し
      dbUserCustomOptionRef.once('value', function(snapshot) {
        // カスタムボタン設定が存在しない場合
        if (snapshot.val() === null) { return }

        for (var i = 0; snapshot.val().length > i; i++) {
          if (snapshot.val()[i].key !== 'delta' && snapshot.val()[i].key !== 'mono') {
            self.customOption.push(snapshot.val()[i])
          }
        }
      }, function(errorObject) {
      })
      // カスタムボタンが変更されたとき
      dbUserCustomOptionRef.on('child_changed', function(snapshot) {
        /*
        */
      })


      // ----- カスタムSKU設定 -----
      const dbUserCustomSkuRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/sku')
      // カスタムSKU設定の初期呼び出し
      dbUserCustomSkuRef.on('value', function(snapshot) {
        // カスタムSKU設定が存在しない場合は初期値を入力
        if (snapshot.val() === null) {
          self.customSku = self.customSkuDefault
        } else {
          self.customSku = snapshot.val()
        }
        // カスタムSKUを解析する
        self.customSkuOption = self.paramAnalysis(self.customSku)
      }, function(errorObject) {
      })
      // カスタムSKUが変更されたとき
      dbUserCustomSkuRef.on('child_changed', function(snapshot) {
        if (snapshot.val() === null) {
          self.customSku = self.customSkuDefault
        } else {
          self.customSku = snapshot.val()
        }
        // カスタムSKUを解析する
        self.customSkuOption = self.paramAnalysis(self.customSku)
      })

      // ----- カスタムCSV設定 -----
      const dbUserCustomCSVRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/csv')
      // カスタムCSV設定の初期呼び出し
      dbUserCustomCSVRef.on('value', function(snapshot) {
        // カスタムCSV設定が存在しない場合
        if (snapshot.val() === null) {
          //self.customCSVOption = self.paramAnalysis(csvDefault.join())
        } else {
          // カスタムCSVを解析する
          self.customCSVOption = self.paramAnalysis(snapshot.val())
        }
        
      }, function(errorObject) {
      })
      // カスタムCSVが変更されたとき
      dbUserCustomCSVRef.on('child_changed', function(snapshot) {
        // カスタムCSVを解析する
        self.customCSVOption = self.paramAnalysis(snapshot.val())
      })

      // ----- 設定 -----
      const dbUserSettingRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting')
      // カスタムSKU設定の初期呼び出し
      dbUserSettingRef.on('value', function(snapshot) {

        self.settingCheck(snapshot.val())
        /*
        // カスタムSKU設定が存在しない場合
        if (snapshot.val() === null) {
          //self.customCSVOption = self.paramAnalysis(csvDefault.join())
        } else {
          // カスタムオプションを解析する
          self.customCSVOption = self.paramAnalysis(snapshot.val())
        }
        */
      }, function(errorObject) {
      })
      // カスタムボタンが変更されたとき
      dbUserSettingRef.on('child_changed', function(snapshot) {
        /*
        // カスタムオプションを解析する
        self.customCSVOption = self.paramAnalysis(snapshot.val())
        */
        self.settingCheck(snapshot.val())
      })

      // ----- RemoteConfig設定 -----
      // RemoteConfigから検索APIの間隔を取得する
      var remoteConfig = firebase.remoteConfig()
      remoteConfig.fetchAndActivate()
        .then(() => {
          this.searchApiInterval = remoteConfig.getValue('webSearchApiInterval').asNumber()
        })
        .catch((err) => {
          console.error(err);
        });

      // firebaseから設定の呼び出し
      /*
      const firebaseCurrentUser = firebase.auth().currentUser
      const dbSettingRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting')
      dbSettingRef.on('value', (data) => {
      })*/
    },
    // ■ ユーザーの設定項目をチェックする
    settingCheck(settings) {
      // ispro（プロアカウントを契約していない場合）はログインページへリダイレクト
      if (settings === null) {
        this.$router.push('/pages/login').catch(() => {})
      } else if (typeof settings.ispro !== 'undefined' && !settings.ispro) {
        this.$router.push('/pages/login').catch(() => {})
      } else {
        // 出品登録フラグのチェック
        if (typeof settings.ismwsapi_v2 !== 'undefined' || typeof settings.mws_v2 !== 'undefined') {
          this.promptFlag = true
        }  
      }
    },
    // ■ 出品処理
    itemExhibitInput(asin) {
      /*
      ○■// sku: 時間？（2020092315001）カスタムSKU設定を取得してくる。ない場合は？
      // stock:
      // // AmazonPay: 【確認】amazonの手数料合計
      // // arariprice: 0
      ○▲// // condition: 選択させる
      ○▲// // conditionnote: 入力させる
      // // fbasendpay: 【確認】
      // // isfba: 【確認】
      // // otherpay: 【確認】
      ○▲// // salecount: 【確認】出品数
      ○▲// // salepoint: 【確認】ポイント
      ○▲// // saleprice: 【確認】出品価格
      ○▲// // shipping: 【確認】送料（FBAの場合は0）
      // // stockdatetime: timestamp
      // // stocknote: 入力させる
      // // stockprice: 
      // // storagePay:
      // // weightPay: 
      // // workPay: 配送数料
      */


      // 初期化
      this.prompt = JSON.parse(JSON.stringify(this.promptInit))

      // モーダルウィンドウをON
      //this.popupStockInput = true

      // asinからアイテム情報を取得
      let baseItemValue = this.customFormation(asin,this.itemHistory[asin],this.itemHistoryAsin[this.itemHistory[asin].displayId])

      // info情報があったときに対象の情報を入力する
      if(typeof this.itemHistory[asin].stock !== 'undefined') {
        if(typeof this.itemHistory[asin].stock.AmazonPay !== 'undefined') {
          this.prompt.stock.AmazonPay = this.itemHistory[asin].stock.AmazonPay
        }
        if(typeof this.itemHistory[asin].stock.arariprice !== 'undefined') {
          this.prompt.stock.arariprice = this.itemHistory[asin].stock.arariprice
        }
        if(typeof this.itemHistory[asin].stock.condition !== 'undefined') {
          this.prompt.stock.condition = this.itemHistory[asin].stock.condition
        }
        if(typeof this.itemHistory[asin].stock.conditionnote !== 'undefined') {
          this.prompt.stock.conditionnote = this.itemHistory[asin].stock.conditionnote
        }
        if(typeof this.itemHistory[asin].stock.fbasendpay !== 'undefined') {
          this.prompt.stock.fbasendpay = this.itemHistory[asin].stock.fbasendpay
        }
        if(typeof this.itemHistory[asin].stock.isfba !== 'undefined') {
          this.prompt.stock.isfba = this.itemHistory[asin].stock.isfba
        }
        if(typeof this.itemHistory[asin].stock.otherpay !== 'undefined') {
          this.prompt.stock.otherpay = this.itemHistory[asin].stock.otherpay
        }
        if(typeof this.itemHistory[asin].stock.salecount !== 'undefined') {
          this.prompt.stock.salecount = this.itemHistory[asin].stock.salecount
        }
        if(typeof this.itemHistory[asin].stock.salepoint !== 'undefined') {
          this.prompt.stock.salepoint = this.itemHistory[asin].stock.salepoint
        }
        if(typeof this.itemHistory[asin].stock.saleprice !== 'undefined') {
          this.prompt.stock.saleprice = this.itemHistory[asin].stock.saleprice
        }
        if(typeof this.itemHistory[asin].stock.shipping !== 'undefined') {
          this.prompt.stock.shipping = this.itemHistory[asin].stock.shipping
        }
        if(typeof this.itemHistory[asin].stock.stockdatetime !== 'undefined') {
          this.prompt.stock.stockdatetime = this.itemHistory[asin].stock.stockdatetime
        }
        if(typeof this.itemHistory[asin].stock.stocknote !== 'undefined') {
          this.prompt.stock.stocknote = this.itemHistory[asin].stock.stocknote
        }
        if(typeof this.itemHistory[asin].stock.stockprice !== 'undefined') {
          this.prompt.stock.stockprice = this.itemHistory[asin].stock.stockprice
        }
        if(typeof this.itemHistory[asin].stock.storagePay !== 'undefined') {
          this.prompt.stock.storagePay = this.itemHistory[asin].stock.storagePay
        }
        if(typeof this.itemHistory[asin].stock.weightPay !== 'undefined') {
          this.prompt.stock.weightPay = this.itemHistory[asin].stock.weightPay
        }
        if(typeof this.itemHistory[asin].stock.workPay !== 'undefined') {
          this.prompt.stock.workPay = this.itemHistory[asin].stock.workPay
        }
      } else {
        // 出品価格へカート価格を挿入。カート価格が0であれば販売価格を挿入
        if (baseItemValue.cart > 0) {
          this.prompt.stock.saleprice = baseItemValue.cart
        } else if (baseItemValue.used > 0) {
          this.prompt.stock.saleprice = baseItemValue.used
        } else {
          this.prompt.stock.saleprice = baseItemValue.price
        }
      }

      // 共通の情報を挿入
      for (var i = 0; this.itemConditionLabel.length > i; i++){
        if (this.itemConditionLabel[i].value === this.prompt.stock.condition) {
          this.prompt.stock.condition = this.itemConditionLabel[i]
          break
        }
      }
      this.prompt.asin = asin
      this.prompt.stock.stockdatetime = moment().unix()
      this.prompt.timestamp = moment().unix()
      this.prompt.sku = baseItemValue.sku
    },
    // ■ 現在の入力情報をDBに保存する
    saveExhibitData(asin) {
      // 商品情報がDBにあるかのチェック
      const firebaseCurrentUser = firebase.auth().currentUser
      const dbItemsRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/' + this.readFirebaseItem + '/' + asin)
      const self = this
      let saveData = JSON.parse(JSON.stringify(this.prompt))
      let itemData = JSON.parse(JSON.stringify(this.itemHistory[asin]))
      // データの形成
      delete itemData.displayId // ロード時に付与した不要なデータを削除
      //saveData.stock.condition = saveData.stock.condition.value // コンディションの指定の値のみを入れる
      itemData.stock = saveData.stock // 対象のデータを挿入
      itemData.stock.condition = itemData.stock.condition.value // 対象のデータを挿入
      /*

      dbItemsRef.once('value', function(snapshot) {
      })
      */

      dbItemsRef.update(itemData)


      this.$vs.notify({
        title:'出品情報の保存が完了しました',
        text: '',
        color:'success',
        icon:'check'
      })
    
      // 変更する値　
      //// FBA利用
      //// 出品価格
      //// 送料
      //// ポイント
      //// 出品数
      //// コンディション
      //// コンディション説明
      
    },
    // ■ 出品処理前の内容確認
    promptConfirmation() {
      // 出品フラグがオンだったら 
      if (this.promptFlag) {
        // モーダルウィンドウをON
        this.popupPrompt = true
      } else {
        this.$vs.dialog({
          color:'warning',
          title: 'MWS API エラー',
          text: 'スマートフォンアプリ「Amacode」の[設定]より[MWS API]の設定を行ってください。',
          accept:this.acceptAlert
        })
      }
    },
    // ■ 出品処理
    itemExhibit() {
      // モーダルウィンドウをOFF
      this.popupStockInput = false
      this.popupPrompt = false
      // データをDB登録用に形成
      this.prompt.stock.condition = this.prompt.stock.condition.id // コンディションの指定の値のみを入れる
      const firebaseCurrentUser = firebase.auth().currentUser
      const exhibitData = {
        [this.prompt.asin]: this.prompt
      }

      // 出品処理
      const dbPostsRef = firebase.database().ref('posts/' + firebaseCurrentUser.uid + '/')
      // データ登録
      dbPostsRef.update(exhibitData)
      // 完了アラート
      this.$vs.notify({
        title:'出品が完了しました',
        text: '',
        color:'success',
        icon:'check'
      })
    },
    // ■ クラスの付与するしない
    toggleClass: function (data) {
      if (this.showButton.indexOf(data) >= 0) {
        this.showButton = this.showButton.filter(n => n !== data)
      }
 
      else {
        this.showButton.push(data)
      }
    },
    // ■ バーコードスキャンをする
    startScanBarcode() {
      this.scanOn = true
      this.code = "";
      this.initQuagga();
    },
    // ■ バーコードスキャンを止める
    stopScan() {
      if (this.scanOn) {
        this.Quagga.offProcessed(this.onProcessed)
        this.Quagga.offDetected(this.onDetected)
        this.scanOn = false
        this.Quagga.stop()
      }
    },
    // ■ バーコードスキャンの設定・初期化
    initQuagga() {
      this.Quagga = require("quagga");
      this.Quagga.onProcessed(this.onProcessed);
      this.Quagga.onDetected(this.onDetected);

      // 設定
      const config = {
        inputStream: {
          name: "Live",
          type: "LiveStream",
          target: document.querySelector("#cameraArea"),
          constraints: { facingMode: "environment" }
        },
        numOfWorkers: navigator.hardwareConcurrency || 4,
        decoder: {
          readers: ["ean_reader", "ean_8_reader", "upc_reader", "upc_e_reader"]
        }
      };
      this.Quagga.init(config, this.onInit);
    },
    // ■ バーコードスキャンの開始
    onInit(err) {
      if (err) {
        return
      }
      this.Quagga.start();
    },
    // ■ バーコードを検出
    onDetected(success) {
      
      if (validbarcode(success.codeResult.code) && this.codeFlag) {
        if (this.codeArr.indexOf(success.codeResult.code) == -1){
          const self = this
          this.codeFlag = false
          this.codeArr.push(success.codeResult.code)
          // 取得時の画像を表示
          //const $resultImg = document.getElementById("resultImg");
          //$resultImg.setAttribute("src", this.Quagga.canvas.dom.image.toDataURL());
          //this.Quagga.stop()
          this.$EventBus.$emit('inputSearch',success.codeResult.code)
          setTimeout(function(){
            //self.startScanBarcode()
            //$resultImg.setAttribute("src", '');
            self.codeFlag = true
          }, 1000);
        }
      }
      

      
    },
    onProcessed(result) {
      const drawingCtx = this.Quagga.canvas.ctx.overlay;
      const drawingCanvas = this.Quagga.canvas.dom.overlay;

      if (result) {
        // 検出中の緑の線の枠
        if (result.boxes) {
          drawingCtx.clearRect(0, 0, drawingCanvas.width, drawingCanvas.height);
          const hasNotRead = (box) => box !== result.box;
          result.boxes.filter(hasNotRead).forEach((box) => {
            this.Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: "green",
              lineWidth: 2
            });
          });
        }

        // 検出に成功した瞬間の青い線の枠
        if (result.box) {
          this.Quagga.ImageDebug.drawPath(
            result.box,
            { x: 0, y: 1 },
            drawingCtx,
            {
              color: "blue",
              lineWidth: 2
            }
          );
        }

        // 検出に成功した瞬間の水平の赤い線
        if (result.codeResult && result.codeResult.code) {
          this.Quagga.ImageDebug.drawPath(
            result.line,
            { x: "x", y: "y" },
            drawingCtx,
            {
              color: "red",
              lineWidth: 2
            }
          );
        }
      }
    },
    // ■ 検索関数の呼び出し
    searchCall() {
      this.$EventBus.$emit('searchCall')
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    // ■ 詳細検索用のカテゴリを取得する
    async getCategory(){
      const self = this
      // カテゴリの取得
      var getCategoryList = firebase.functions().httpsCallable('getCategoryList')
      // 検索APIで対象の検索結果を呼び出し
      /*
      const asyncSearchCategoryGet = async (value) => {
        getCategoryList().then(function(result) {
          
        })
      }
      asyncSearchCategoryGet().then(result => {})
      */
      let catResult = await getCategoryList()

      if (catResult.data.length > 0) {
        for (var j = 0; catResult.data.length > j; j++) {
          if (!self.searchCategoryRemove.includes(catResult.data[j].name)) {
            let item = {}
            item.label = catResult.data[j].name
            item.id = catResult.data[j].cid
            item.value = catResult.data[j].cid
            item.count = catResult.data[j].productCount
            self.searchCategory.push(item)
          }
        }
      }
      return catResult

      this.$vs.loading.close()
    },
    // ■ 引数の文字列からサジェストを取得する
    suggestWord(word) {
      
      if (this.selectFlag) {
        this.selectFlag = false
        return
      }

      if (word !== '') {
        this.suggestDisplay = true
        const searchword = encodeURIComponent(word)
        const url = 'https://completion.amazon.co.jp/search/complete?search-alias=aps&mkt=6&method=completion&q=' + searchword
        jsonp(url, null, (err, data) => {
          if (err) {
            //console.error(err.message)
          } else {
            this.suggestArr = data[1]
          }
        })
        
      } else {
        //this.searchWord = ''
        this.suggestDisplay = false
        this.suggestArr = []
      }
    },
    // ■ 引数のワードをインプットへ挿入する
    suggestWordSelect(word) {
      this.searchForm.word = word
      this.selectFlag = true
      this.suggestDisplay = false
    },
    // ■ フォーカスが外れた場合に非表示をする
    suggestReset(event) {
      const self = this
      //this.searchDetailProducts(true).then(res =>{})
      
      if (event.relatedTarget === null) {
        this.suggestDisplay = false
        return
      }
      /*
      this.suggestDisplay = false
        return
        */
    },
    // ■ 対象の文字列を渡してsearchをする
    async itemWordSearch() {
      if (this.logdingFlag) { return }

      this.logdingFlag = true

      // asin配列の数が100以上だったら無限スクロールを読み込みをさせる
      /*
      if (this.searchAsinArr.length >= 100) {
        this.loadEndFlag = false
      } else {
        this.loadEndFlag = true
      }
      */

      const self = this

      // ローダーの表示
      //this.$vs.loading()
      this.$vs.loading.close()

      // 商品検索APIから対象の商品を取得する
      var searchProducts = firebase.functions().httpsCallable('searchProducts_v2')

      // 検索APIで対象の検索結果を呼び出し
      const asyncProductGet = async (value) => {
        if (value == null || value === 'undefined' || value === '') { return }
        try {
          const result = await searchProducts({text: value})
          if (result.data.result === 'ok') {
            for (var j = 0; result.data.data.length > j; j++) {
              self.searchArrSave.push(result.data.data[j])
              self.searchArr.push(result.data.data[j])
            }
          } else {
            self.searchArrNg.push(result.data.text)
            self.$vs.loading.close()
          }
        } catch (error) {
          //console.error('Error calling searchProducts_v2:', error)
          self.$vs.loading.close()
        }
      }

      /*
      const asyncProductGet = async (value) => {
        const result = await this.searchDetailProducts(first)
        if (result.data.asinList.length > 0) {
          self.searchAsinArr = result.data.asinList
          // 取得したasin配列を元に検索する
          self.itemWordSearch(result.data)
        } else {
          self.$vs.loading.close()
          self.loadFlag = true
        }
        return result
      }
      asyncProductGet().then(result => {})
      */

      //if(!this.searchAwateFlag) { break }

      const result02 = await asyncProductGet(this.searchAsinArr[this.searchItemNow]).then(result => {
        self.$vs.loading.close()
        this.searchItemNow++
        this.searchItemNextCount++
        if (this.searchItemNow >= this.searchAsinArr.length) {
          this.loadEndFlag = true
          this.logdingFlag = true
          if(this.searchMode){
            this.loadEndFlag = false
            this.logdingFlag = true
            this.loadingEndFlag = true
          }
        } else {
          //this.loadEndFlag = false
          this.logdingFlag = false
          if (this.searchItemNextCount == 15) {
            this.searchItemNextCount = 0
          } else {
            this.itemWordSearch()
          }
          
        }
      })
    },
    // ■ asinを取得する
    async searchDetailProducts(first){

      /*
      if (!this.searchDelayFlag) { return }
      this.searchDelayFlag = false
      setTimeout( function(){
        this.searchDelayFlag = true
      }, 1000 )
      */

      const self = this
      

      // 初回読み込み
      if (first){
        this.searchTotalResults = "..."
        this.searchAsinArr = []
      }

      let detailSearchOption = {}
      // cid : //カテゴリーID (getCategoryList を参照)
      if (this.searchForm.category != null) {
        if (Object.keys(this.searchForm.category).length) {
          detailSearchOption.cid = this.searchForm.category.id
        }
      }
      if (this.searchForm.is_Amazon_outOfStock) { // アマゾン省く
        detailSearchOption.is_Amazon_outOfStock = 1
      }
      if (this.searchForm.is_New_outOfStock) {
        detailSearchOption.is_New_outOfStock = 1
      }
      if (this.searchForm.is_Used_outOfStock) {
        detailSearchOption.is_Used_outOfStock = 1
      }
      // 数字以外のときは弾く
      // テキストを受け取る
      // 検索する
      // 検索結果を表示する
      if (this.searchForm.current_SALES_gte != null){       //ランキング 以上
        detailSearchOption.current_SALES_gte = this.searchForm.current_SALES_gte
      }
      if (this.searchForm.current_SALES_lte != null){       //ランキング 以内
        detailSearchOption.current_SALES_lte = this.searchForm.current_SALES_lte
      }
      if (this.searchForm.current_NEW_gte != null){         //新品価格(円) 以上
        detailSearchOption.current_NEW_gte = this.searchForm.current_NEW_gte
      }
      if (this.searchForm.current_NEW_lte != null){        //新品価格(円) 以下
        detailSearchOption.current_NEW_lte = this.searchForm.current_NEW_lte
      }
      if (this.searchForm.deltaPercent90_NEW_gte != null){  //新品 90日間の割引率(%) 以上
        detailSearchOption.deltaPercent90_NEW_gte = this.searchForm.deltaPercent90_NEW_gte
      }
      if (this.searchForm.deltaPercent90_NEW_lte != null){  //新品 90日間の割引率(%) 以下
        detailSearchOption.deltaPercent90_NEW_lte = this.searchForm.deltaPercent90_NEW_lte
      }
      if (this.searchForm.current_COUNT_NEW_gte != null){   //新品出品者数 以上
        detailSearchOption.current_COUNT_NEW_gte = this.searchForm.current_COUNT_NEW_gte
      }
      if (this.searchForm.current_COUNT_NEW_lte  != null){  //新品出品者数 以下
        detailSearchOption.current_COUNT_NEW_lte  = this.searchForm.current_COUNT_NEW_lte 
      }
      if (this.searchForm.current_USED_gte != null){        //中古価格(円) 以上
        detailSearchOption.current_USED_gte = this.searchForm.current_USED_gte
      }
      if (this.searchForm.current_USED_lte != null){        //中古価格(円) 以下
        detailSearchOption.current_USED_lte = this.searchForm.current_USED_lte
      }
      if (this.searchForm.deltaPercent90_USED_gte != null){  //中古 90日間の割引率(%) 以上
        detailSearchOption.deltaPercent90_USED_gte = this.searchForm.deltaPercent90_USED_gte
      }
      if (this.searchForm.deltaPercent90_USED_lte != null){  //中古 90日間の割引率(%) 以下
        detailSearchOption.deltaPercent90_USED_lte = this.searchForm.deltaPercent90_USED_lte
      }
      if (this.searchForm.current_COUNT_USED_gte != null){  //中古出品者数 以上
        detailSearchOption.current_COUNT_USED_gte = this.searchForm.current_COUNT_USED_gte
      }
      if (this.searchForm.current_COUNT_USED_lte != null){ //中古出品者数 以下
        detailSearchOption.current_COUNT_USED_lte = this.searchForm.current_COUNT_USED_lte
      }

      if (this.searchForm.word != '') { // 検索ワード
        // 対象の文字を配列へ変換
        let searchWordSave = this.searchForm.word.split(/[, ]/)
        let searchWord = []

        // 配列が100以上あった場合
        if (searchWordSave.length > 100) {
          for (var i = 0; 100 > i; i++){
            searchWord.push(searchWordSave[i])
          }
        } else {
          searchWord = searchWordSave
        }
        detailSearchOption.text = searchWord.join(' ')
      }
      // ページ
      if (first == true) {
        detailSearchOption.page = 0
      } else {
        detailSearchOption.page = this.searchForm.page
      }

      // 商品検索APIから対象の商品を取得する
      var searchProducts = firebase.functions().httpsCallable('searchDetailProducts')
      const result = await searchProducts(detailSearchOption)
      if (first){
        this.searchTotalResults = result.data.totalResults
      }
      return result

    },
    // ■ 詳細検索
    detailSearch(first) {
      // 非同期関数の終了まで待つ
      this.searchAwateFlag = false
      const self = this
      
        //self.suggestReset()
        self.searchAwateFlag = true

        // 初回検索時
        if (first) {
          self.loadEndFlag = false
          self.logdingFlag = false
          //self.searchAsinArr.splice(0, self.searchAsinArr.length)
          self.searchAsinArr = []
          //self.searchArrSave.splice(0, self.searchArrSave.length)
          self.searchArrSave = []
          //self.searchArr.splice(0, self.searchArr.length)
          self.suggestDisplay = false
          self.searchMode = false
          self.searchArr = []
          self.searchArrNg = []
          self.searchItemNow = 0
          //self.searchItemNextCount = self.searchItemCount * 2
          self.searchItemNextTotal = self.searchItemTotal
          self.searchForm.page = 0
          self.addSearchHistory(self.searchForm)
        } else {
          self.loadEndFlag = false
          self.logdingFlag = false
          //self.searchArr = []
          //self.searchArrNg = []
          self.searchItemNow = 0
        }

        // init
        self.$vs.loading()

        let searchWordSave = self.searchForm.word.split(/[, ]/)
        let wordCheck = false

        // カンマ区切りの文字列をそれぞれチェック
        for (var s = 0; searchWordSave.length > s; s++) {
          if (wordCheck) { break }
          wordCheck = self.codeCheck(searchWordSave[s])
        }

        // asin か 文字列 かで処理を分岐
        if (wordCheck) {
          self.searchMode = true
          // 対象の文字を配列へ変換
          let searchWord = []
          for (var i = 0; searchWordSave.length > i; i++){
            if (i == 100) { break } // 配列が100以上あった場合
            self.searchAsinArr.push(searchWordSave[i].trim())
          }
          self.itemWordSearch()
          this.searchTotalResults = '-'
        } else {
          const asyncProductGet = async (value) => {
            const result = await self.searchDetailProducts(first)
            if (result.data.asinList.length > 0) {
              self.searchAsinArr = result.data.asinList
              // 取得したasin配列を元に検索する
              //this.logdingFlag = true
              self.itemWordSearch()
            } else {
              self.$vs.loading.close()
              self.loadEndFlag = false
              self.logdingFlag = true
              self.loadingEndFlag = true
            }
            return result
          }
          asyncProductGet().then(result => {})
        }
      //setTimeout( function(){}, 800 )
    },
    // ■ 検索条件のリセット
    searchDetailReset(){
      this.searchForm = JSON.parse(JSON.stringify(this.searchFormInit))
      this.searchTotalResults = "-"
    },
    // 詳細検索のページ無限スクロール
    searchInfinitePageHandler($state) {
      // 無限スクロールの読み込みフラグがfalseであれば処理を終了
      if(!this.loadEndFlag){ return }
      // 次ページのリクエスト
      this.searchForm.page++
      this.detailSearch(false)
    },
    // 詳細検索の製品無限スクロール
    searchInfiniteHandler($state) {
      if(!this.logdingFlag){
        this.$vs.loading()
        this.itemWordSearch()
        return
      }

      /*
      if (this.searchArr.length + this.searchArrNg.length >= this.searchItemNextTotal) {
        if (this.logdingFlag) {
          // 読み込み回数を1プラス
          this.searchForm.page++
          this.searchItemNextTotal = this.searchItemTotal * (this.searchForm.page + 1)
          // 詳細検索
          this.detailSearch(false)
        } else {
          //$state.complete()

        }
      }
      */
      
    },
    // ■ 引数の文字列がASIN、ISBN、であればtrue
    codeCheck (code) {
      if(code == ''){return false}

      let result = false

      if(barcoder.validate(code)) { // barcoder
        result = true
      }
      if (ISBN.Validate(code)) { // ISBN
        result = true
      }
      if (code.match(/^B[\dA-Z]{9}|\d{9}(X|\d)$/)) { // asin
        result = true
      }

      return result
    },
    // ■ realtime databaseのユーザー設定に検索履歴を書き込みをする
    addSearchHistory(option) {
      /*
      // 不正な値であればreturn
      if (word === null || word === 'undefined' || word === '') { return }

      const firebaseCurrentUser = firebase.auth().currentUser
      const dbUserSearchHistoryRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/searchHistory')
      // データを作成
      const date = new Date()
      const timestamp = Math.floor( date.getTime() )
      let addData = {
        [timestamp]: {
          'searchDate': timestamp,
          'searchWord': word
        }
      }
      // DBへ追加
      dbUserSearchHistoryRef.update(addData)
      */

      // 不正な値であればreturn
      //if (option.word === null || option.word === 'undefined' || option.word === '') { return }

      const firebaseCurrentUser = firebase.auth().currentUser
      const dbUserSearchHistoryRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/searchHistory')


      // データを作成
      const date = new Date()
      const timestamp = Math.floor( date.getTime() )
      let addData = {
        [timestamp]: {
          'searchDate': timestamp,
          'searchWord': option.word,
          'searchOption' : option
        }
      }
      // DBへ追加
      dbUserSearchHistoryRef.update(addData)

    },
    // ■ オブジェクトからundenfinedを取り除く
    removeUndefinedFromObject(object) {
      return Object.fromEntries(
        Object.entries(object).filter(([k, v]) => v !== undefined)
      )
    },
    // ■ 詳細検索のパラメータチェック
    async searchParamInit () {
      // カテゴリ取得
      this.$vs.loading()
      await this.getCategory()

      var toString = Object.prototype.toString;

      // 検索用パラメータが付与されていた場合の処理
      const paramObj = this.getparamAnalysis()

      if (paramObj.s !== null && typeof paramObj.s !== 'undefined' && paramObj.s !== '') {
        this.searchForm.word = paramObj.s
      }
      if (paramObj.cat != null && paramObj.cat !== 'undefined' && paramObj.cat !== '') { // カテゴリ情報
        for (var k in this.searchCategory) {
          if (this.searchCategory[k].label == paramObj.cat) {
            this.searchForm.category = this.searchCategory[k]
            break
          }
        }
      }
      if (paramObj.as != null && paramObj.as !== 'undefined' && paramObj.as !== '') { // Amazon在庫を除外
        this.searchForm.is_Amazon_outOfStock = paramObj.as
      }
      if (paramObj.rg != null && paramObj.rg !== 'undefined' && paramObj.rg !== '') { // ランキング 以上
        this.searchForm.current_SALES_gte = paramObj.rg
      }
      if (paramObj.rl != null && paramObj.rl !== 'undefined' && paramObj.rl !== '') { // ランキング 以内
        this.searchForm.current_SALES_lte = paramObj.rl
      }
      if (paramObj.ng != null && paramObj.ng !== 'undefined' && paramObj.ng !== '') { // 新品価格(円) 以上
        this.searchForm.current_NEW_gte = paramObj.ng
      }
      if (paramObj.nl != null && paramObj.nl !== 'undefined' && paramObj.nl !== '') { // 新品価格(円) 以下
        this.searchForm.current_NEW_lte  = paramObj.nl
      }
      if (paramObj.npg != null && paramObj.npg !== 'undefined' && paramObj.npg !== '') { // 新品 90日間の値下り / 値上り率(%) 以上
        this.searchForm.deltaPercent90_NEW_gte = paramObj.npg
      }
      if (paramObj.npl != null && paramObj.npl !== 'undefined' && paramObj.npl !== '') { // 新品 90日間の値下り / 値上り率(%) 以下
        this.searchForm.deltaPercent90_NEW_lte = paramObj.npl
      }
      if (paramObj.ncg != null && paramObj.ncg !== 'undefined' && paramObj.ncg !== '') { // 新品出品者数 以上
        this.searchForm.current_COUNT_NEW_gte = paramObj.ncg
      }
      if (paramObj.ncl != null && paramObj.ncl !== 'undefined' && paramObj.ncl !== '') { // 新品出品者数 以下
        this.searchForm.current_COUNT_NEW_lte  = paramObj.ncl
      }
      if (paramObj.ns != null && paramObj.ns !== 'undefined' && paramObj.ns !== '') { // 新品在庫なし
        this.searchForm.is_New_outOfStock = paramObj.ns
      }
      if (paramObj.ug != null && paramObj.ug !== 'undefined' && paramObj.ug !== '') { // 中古価格(円) 以上
        this.searchForm.current_USED_gte = paramObj.ug
      }
      if (paramObj.ul != null && paramObj.ul !== 'undefined' && paramObj.ul !== '') { // 中古価格(円) 以下
        this.searchForm.current_USED_lte = paramObj.ul
      }
      if (paramObj.upg != null && paramObj.upg !== 'undefined' && paramObj.upg !== '') { // 中古 90日間の値下り / 値上り率(%) 以上
        this.searchForm.deltaPercent90_USED_gte = paramObj.upg
      }
      if (paramObj.upl != null && paramObj.upl !== 'undefined' && paramObj.upl !== '') { // 中古 90日間の値下り / 値上り率(%) 以下
        this.searchForm.deltaPercent90_USED_lte = paramObj.upl
      }
      if (paramObj.ucg != null && paramObj.ucg !== 'undefined' && paramObj.ucg !== '') { // 中古出品者数 以上
        this.searchForm.current_COUNT_USED_gte = paramObj.ucg
      }
      if (paramObj.ucl != null && paramObj.ucl !== 'undefined' && paramObj.ucl !== '') { // 中古出品者数 以下
        this.searchForm.current_COUNT_USED_lte = paramObj.ucl
      }
      if (paramObj.us != null && paramObj.us !== 'undefined' && paramObj.us !== '') { // 中古在庫なし
        this.searchForm.is_Used_outOfStock = paramObj.us
      }
      // 検索ワードがundefinedのときは必ず空の値を挿入
      this.searchForm = this.removeUndefinedFromObject(this.searchForm)
      if (typeof this.searchForm.word === "undefined") {
        this.searchForm.word = ""
      }
      //return Object.is(this.searchForm,this.searchFormInit)
    }
  },
  created() {
    const appLoading = document.getElementById('app')
    appLoading.classList.remove("login-view")
    // 別コンポーネントからの呼び出し登録
    //（/src/layouts/components/navbar/components/DownloadDropDown.vue）
    this.$EventBus.$on('stockCsvExportCall', () => {
      this.csvSurfaceVisible()
    })

    // 検索ページ用
    this.$EventBus.$on('searchWord', data => {
      if (data != null && data !== 'undefined' && data !== '') {
        this.suggestWordSelect(data)
        this.detailSearch(true)
      }
    })

    // バーコードスキャンイベント
    this.$EventBus.$on('barcodeScan', data => {
      if (data != null && data !== 'undefined' && data !== '') {
        if (data) {
          this.startScanBarcode()
        } else {
          this.stopScan()
        }
      }
    })

    // 詳細検索
    this.$EventBus.$on('searchDetailWord', data => {
      if (data != null && data !== 'undefined' && data !== '') {
        if (data) {
          this.searchDetailDisplay = false
        } else {
          this.searchDetailDisplay = true
        }
      }
    })

    // 詳細検索をストップする
    this.$EventBus.$on('searchStop', data => {
      if (data != null && data !== 'undefined' && data !== '') {
        if (data) {
          this.logdingFlag = true
        } else {
          this.logdingFlag = false
        }
      }
    })
  },
  filters: {
    addComma: function(value) {
      return value.toLocaleString();
    }
  },
  beforeMount() {
  },
  mounted: function(){

    // 設定の初期化
    this.settingInit()

    // 初回データの読み込み
    this.getItemHistory()

    // 商品詳細表示（q=asin）パラメータが付与されていた場合の処理
    const paramQ = this.getparamAnalysis('q')
    if (paramQ != null && paramQ !== 'undefined' && paramQ !== '') {
      this.dataGraphVisible(paramQ)
    }

    // 検索ページ
    if (this.readFirebaseItem === 'search') {

      this.searchParamInit().then(() => {
        // パラメータのsonがあれば検索開始
        const paramSearch = this.getparamAnalysis('son')
        if (paramSearch == 1){
          this.suggestWordSelect(this.searchForm.word)
          this.detailSearch(true)
        }
        this.$vs.loading.close()
      })
      
    }
  },
  filters: {
    moment: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD')
    }
  }
}

</script>

<style lang="scss">
  .router-header {
    justify-content: space-between;
  }

  .price-wrap {
      >.vx-col {
        padding: 0 3px;
      }

      .price-item {
        display: flex;
        align-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        justify-content: center;
        position: relative;
        border-right: 1px solid rgba(0, 0, 0, 0.1);

        &:nth-of-type(3n+3) {
          border-right: none;
        }

        .chip-wrap {
          position: absolute;
          top: 50%;
          right: -10px;
          transform: translate(100%,-50%);
          display: block;
          align-content: center;
          align-items: center;

          flex-wrap: wrap;
          justify-content: center;
          //width: 100%;
        }

        .price {
          display: flex;
          justify-content: center;
          align-items: center;

          @media (max-width: 992px) {
            font-size: 0.9rem;
          }

          .unit {
            margin-left: 3px;
            font-size: 0.8em;
          }

          .con-vs-chip {
            float: none;
            display: inline-flex;
            margin-left: 5px;
          }
        }

        .ttl {
          position: relative;
          font-size: 0.9rem;
        }
      }
    }

  .item-list-view {

    .star-wrap {
      display: flex;
      align-item: center;

      .vue-star-rating {
        display: inline-flex;
        //margin-right: 5px;
      }

      .number {
        line-height: 1.6;
      }
    }

    

    .button-wrap {
      display:flex;
      align-items: center;
      flex-wrap:wrap;
      //justify-content: center;
      .button {
        margin-right: 15px;
        margin-top: 15px;
        .vs-button {
          min-width: 100%;
          padding: 10px 10px !important;
          line-height: 1.2;
          i{
            margin-right:5px;
          }
        }
      }
    }

    .content-wrap {
      min-height: 100vh;
      //align-items: flex-start;
      //width: 58.33333333333333% !important;
      @media only screen and (max-width: 900px){
        //width: 66.66666666666667%!important;
      }
      @media only screen and (max-width: 600px){
        //width: 100% !important
      }



      .list-view-item {
        margin-top: 20px;
        border:2px solid #fff;
        &:first-child {
          margin-top: 0;
        }
        &.is-selected{
          border-color:rgb(115, 103, 240);
        }
      }
      .item-details{
        align-content: center;
        align-items: center;
        position: relative;
        &.item-list{
          .item-details-container{
            width:calc(100% - 320px) !important;
          }
          .item-graph-container{
            width:320px !important;
          }
        }
        .item-name {
          padding-right: 35px;
          clear: both;
          color: inherit;
        }
        .item-asin{
          display:flex;
          align-items:center;
          .icon{
            width:15px;
            margin-right:5px;
          }
        }
        .arrow-icon{
          position: absolute !important;
          top: 50%;
          right:10px;
          transform:translate(0,-50%);
          transition: all .3s ease-in-out;
        }
        .item-details-container{
          position: relative;
          transition: all .3s ease-in-out;
          &.no-hover{
            .arrow-icon{
              display:none;
            }
            &:hover{
              transform: translate(0,0);
            }
          }
          &.item-list{

          }
          &:hover{
            //transform: translate(-5px,-5px);
            
            .arrow-icon{
              //right: 5px;
            }
          }
          .item-img-container{
            position:relative;
            /*
            &:after{
              display:block;
              content:"";
              position: absolute;
              top: 50%;
              left: 50%;
              margin-left:-1.5em;
              margin-top:-1.5em;
              border-radius: 50%;
              width: 3em;
              height: 3em;
              font-size: 10px;
              text-indent: -9999em;
              border-top: 0.5em solid rgba(255, 255, 255, 0.2);
              border-right: 0.5em solid rgba(255, 255, 255, 0.2);
              border-bottom: 0.5em solid rgba(255, 255, 255, 0.2);
              border-left: 0.5em solid rgb(115, 103, 240);
              -webkit-transform: translateZ(0);
              -ms-transform: translateZ(0);
              transform: translateZ(0);
              -webkit-animation: load8 1.1s infinite linear;
              animation: load8 1.0s infinite linear;
              @-webkit-keyframes load8 {
                0% {
                  -webkit-transform: rotate(0deg);
                  transform: rotate(0deg);
                }
                100% {
                  -webkit-transform: rotate(360deg);
                  transform: rotate(360deg);
                }
              }
              @keyframes load8 {
                0% {
                  -webkit-transform: rotate(0deg);
                  transform: rotate(0deg);
                }
                100% {
                  -webkit-transform: rotate(360deg);
                  transform: rotate(360deg);
                }
              }
            }
            */
            &:hover{
              .vs-button{
                opacity: .8;
                transform: translate(-5px, -5px);
              }
            }
          }
          img{
            //z-index:1;
            position:relative;
            max-width: 100%;
            max-height: 150px;
            &[lazy="loaded"]{
              //width: 100px;
              ~ :after{
                display:none;
              }
            }
          }
          .vs-button{
            //width: 100%;
            padding: .4rem 15px !important;
          }
        }
        .item-detail-container{
          display: flex;
          align-items: center;
          .detail-container{
            padding-right: 25px;
            .con-vs-chip{
              margin-right: 10px;
            }
          }
        }

        .item-graph-container{
          position:relative;
          overflow:hidden;
          //height:100%;
          text-align: center;
          transition: all .3s ease-in-out;
          &:hover{
            .vs-button{
              opacity: .8;
              transform: translate(-5px,-5px);
            }
          }
          .graph-detail{
            margin-bottom: 5px;
            font-size: .8rem;
            font-weight: bold;
            >span{
              display:inline-block;
              margin: 0 10px 5px;
            }
          }
          .img{
            position:relative;
            overflow:hidden;
            width:100%;
            height:170px;
            margin: 0 auto;
            img{
              z-index:1;
              position:relative;
              //height: calc(100% - 20px);
              //position: absolute;
              //top: 0;
              //left: 0;
              top: -13px;
              height:100%;
              width: 133%;
            }
            .load{
              z-index:0;
              position: absolute;
              top:50%;
              left:0;
              width:100%;
              text-align:center;
              font-size:0.8rem;
            }
          }
          .vs-button{
            padding: .4rem 15px !important;
          }
        }
      }
    }


    .infinite-loading-container{
      width:100%;
      margin: 5px 0;
    }

    .notice-wrap{
      position: sticky;
      top: 50%;
      left: 50%;
      transform: translate(0,0);
    }  
  }

  .stock-table{
    .vs-table--tbody-table{
      border-spacing: 0;
      background:none;
      tr{
        border-top: 1px solid #f8f8f8;
      }
    }
  }

  .csv-table{
    .vs-table--tbody-table{
      table-layout: fixed;
    }
    .vs-table--thead{
      .vs-table-text{
        justify-content: center;
      }

    }
    th{
      //display: table-caption;
      width:150px;
    }
    .td-check{
      width:30px;
    }
    .th-name{
      width:350px;
    }
    .th-asin {}
    .th-jan {}
    .th-cat {}
    .th-rank {
      width:70px;
    }
    .th-cart {
      width:150px;
    }
    .th-new {
      width:150px;
    }
    .th-used {
      width:150px;
    }
    .th-star {
      width:30px;
    }
    .th-rating {
      width:70px;
    }
    .th-price {
      width:150px;
    }
    .th-list_price {
      width:150px;
    }
    .th-shipping_price {
      width:150px;
    }
    .th-stock_price {
      width:150px;
    }
    .th-stock {
      width:150px;
    }
    .th-gross {}
    .th-condition_id {}
    .th-date {
      width:100px;
    }
    .th-datetime {
      //width:150px;
    }
    .th-timestamp {
      width:100px;
    }
    .th-sku {}
    .th-cat_name {}
    .th-condition {
      width:80px;
    }
    .th-condition_note {
      width:350px;
    }
    .th-note {
      width:350px;
    }
  }

  .tab-wrap {
    display: block !important;
    position: relative;
    overflow-x: hidden;
    //overflow: hidden;
    //max-width: 0;
    //width: 41.66666666666667% !important;
    //min-height:100vh;
    //overflow-y: scroll;
    //padding-left: 20px;
    @media only screen and (max-width: 900px){
      //width: 33.33333333333333%!important;
    }
    @media only screen and (max-width: 600px){
      //width: 100% !important
    }
    .tab-inner {
      //position: sticky;
      //top: 110px;
    }

    .tab-inner-inner {
      //overflow-y: scroll;
      //height: calc(100vh - 110px);
    }

    .vs-tabs--content {
      padding: 20px 0 0;
    }

    .ttl {
      width: 100%;
    }

    .vs-table--tbody-table {
      min-width: auto;
      font-family:monospace;
      .vs-table--thead {
        th {
          .vs-table-text {
            justify-content: center;
            text-align: center;
          }
        }
      }

      .shipping {
        display: flex;
        justify-content: center;

      }

      .unit {
        margin-left: 3px;
        font-size: 0.8em;
      }
    }
  }

  .vs-con-table{
    .vs-con-tbody{
      border:none !important;
    }
  }

  .vs-tabs--li{
    button.vs-tabs--btn{
      //padding: 0 10px;
    }
  }

  .vs-popup--header{
    border-radius: 0;
  }

  .popup-item-detail {
    h6{
      padding-bottom: 10px;
      //border-bottom: 1px solid #ccc;
      //text-align: center;
      font-weight: bold;
    }
    .vs-popup{
      //max-width: calc(100% - 10px);
      //max-height: calc(100% - 10px);
      max-width: 100%;
      max-height: 100%;
      margin: 0;
      border-radius: 0;
    }
    .vs-popup--header{
      padding: 5px 0;
      .vs-popup--title{
        text-align: center;
      }
      .vs-icon{
        display: flex;
        align-items: center;
        transform: translate(-5px,0);
        border: 1px solid #ccc;
        box-shadow: 0 0 0 0;
        line-height: 1;
        &:after{
          content:"閉じる";
          transform: translateY(-2px);
          font-size: 14px;
        }
      }
    }
    .vs-popup--content{
      overflow-x: hidden;
      position: relative;
      width:100%;
      margin: 0;
      padding: 10px;
      .detail-container{
        .item-asin{
          display:flex;
          align-items:center;
          .icon{
            width:15px;
            margin-right:5px;
          }
        }
      }
    }
    .vs-table{
      background: #f8f8f8;
      tbody{
        tr{
          &:nth-of-type(odd){
            background-color: transparent !important;
          }
          &:first-child{
            th,td{
              //border-top: none;
            }
          }
          th,td{
            //border-top: 1px solid rgba(#ccc,.5);
          }
        }
      }
    }
  }

  .btn-csvexport{
    position: fixed;
    bottom: 30px;
    right: 40px;
    z-index: 1000;
  }

  .popup-item-graph{
    .vs-popup--content{
      max-height: calc(100% - 50px);
      //height: 100%;
      .table-graph{
        @media only screen and (max-width: 768px){
          padding: 50px 0;
        }
      }
      .item-details-container{
        .item-img-container{
          width: 150px !important;
        }
        .item-detail-container{
          width: calc(100% - 150px) !important;
        }
      }
    }
  }

  .itemGraph {
    //display: flex;
    //justify-content: center;
    //align-items: center;
    //align-content: center;
    //height: 100%;
    #chartdiv{
      width: 100%;
      height: 500px;
    }
  }

  .table-graph{
    //z-index: 1000000;
    //position: fixed;
    //top: 0;
    //left: 0;
    width:100%;
    //height: 100vh;
    padding:50px;
    background-color: #fff;
    th,td{
      &.date{
        width:17% !important;
        border-left:none;
      }
      &.ranking{
        width:9% !important;
      }
      &.sprice_n{
        width:23% !important;
      }
      &.count_new{
        width:12% !important;
      }
      &.sprice_u{
        width:23% !important;
      }
      &.count_used{
        width:12% !important;
      }
    }
    .vs-con-tbody,
    .vs-table{
      background: transparent;
    }
    tr{
      //border-top: 1px solid #e2e0e0;
      background: transparent;
      th,td{
        position:relative;
        border: 1px solid #e2e0e0;
        /*
        &:before{
          content:"";
          display:block;
          position: absolute;
          top: 50%;
          left:0;
          transform:translate(0,-50%);
          height:40%;
          border-left: 1px solid #e2e0e0;
        }
        */
      }
    }
    td{
      text-align: right;
      &.date{
        text-align: left;
      }
      span{
        display:block;
      }
    }
    .emphasis{
      color:#fff !important;
      &.rank{
        //background-color:#7366f0;
        background-color: #29c76f;
      }
      &.new{
        //background-color:#23b701;
        background-color: #7366f0;
      }
      &.newcount{
        //background-color:#29c76f;
        background-color: #1700f9;
      }
      &.used{
        //background-color:#f3bf30;
        background-color: #000000;
      }
      &.usedcount{
        //background-color:#ff9e43;
        background-color: #696969;
      }
    }
    .td-check{
      border-right:none;
      .vs-icon{
        left: -15px;
      }
    }
    .vs-table--thead{
      tr{
        border-top: none;
        th{
          text-align: center !important;
          width:16%;
          &:nth-of-type(1){
            width:4%;
          }
          .vs-table-text{
            justify-content:center;
          }
        }
      }
    }
    .vs-table--tr{
      &:hover{
        transform: translateY(0) !important;
        background-color: #efefef;
      }
    }
    .tr-expand{
      border:none;
      >td{
        border:none;
      }
    }
    .content-tr-expand{
      padding:0;
      border:none;
      table{
        thead{
          display:none;
          //opacity:0;
          height:0;
          th{
            padding:0 !important;
            font-size:0;
          }
        }
        tr{
          border-top: 1px solid #eaeaea;
          &:nth-of-type(odd){
            background-color:#f7f7f7;
          }
        }
        th,td{
          padding: 5px 15px 5px calc(10px + 1em);
        }
      }
    }
    .color_rank{
      //color: #7366f0;
      color: #29c76f;
    }
    .color_new{
      //color: #23b701;
      color: #7366f0;
    }
    .color_newcount{
      //color: #29c76f;
      color: #1700f9;
    }
    .color_used{
      //color: #f3bf30;
      color: #000000;
    }
    .color_usedcount{
      //color: #ff9e43;
      color: #696969;
    }
  }
  
  .item-deteil{
    .vx-card{
      box-shadow: 0 0 0 0;
    }
    .star-wrap{
      display: flex;
    }
  }

  .vs-button{
    &.small-btn{
      margin-right:10px;
      //margin-bottom:10px;
      padding: 5px 10px !important;
      &:last-child{
        margin-right:0;
      }
    }
  }

  .graph-btn-wrap{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-end;
    z-index:1;
    position:relative;
    color:#fff;
    @media only screen and (max-width: 768px){
      //width:768px;
    }
    .vs-button{
      //margin-right:0;
      padding: 8px 10px !important;
      border-bottom:none;
      color:#fff !important;
      &:disabled{
        opacity:1;
      }
      &:hover{
        box-shadow: none;
      }
    }
    .all-btn{
      display:flex;
      align-items: flex-end;
      order:0;
      @media only screen and (max-width: 900px){
        order:1;
      }
      .vs-button{
        padding-left: 30px !important;
        padding-right: 30px !important;
        border-radius:6px 6px 0 0;
        border-bottom:none !important;
        transition: none;
        background-color:#ff9f43 !important;
        &:before{
          display:none;
          content:"";
          position:absolute;
          bottom:-1px;
          left:0;
          width:100%;
          border-top:1px solid #7366f0;
        }
        &:hover,
        &:disabled{
          padding-bottom: 13px !important;
        }
      }
      .btn-new{
        //background-color:#26AE90 !important;
        background-color:rgb(115,103,240) !important;
      }
      .btn-use{
        //background-color:#f3bf30 !important;
        background-color:#000000 !important;
      }
    }
    .date-btn{
      //width:100%;
      order:1;
      padding: 0 0 5px;
      @media only screen and (max-width: 900px){
        order:0;
      }
      .vs-button{
        overflow: visible;
        position: relative;
        margin-left: 10px;
        margin-right: 10px;
        padding: 5px 20px !important;
        background-color: transparent !important;
        color: #333 !important;
        &:before{
          content:"";
          display:block;
          position: absolute;
          top:50%;
          right:-10px;
          transform: translate(0,-50%);
          height: 50%;
          border-right:1px solid #ccc;
        }
        &:hover,
        &:disabled{
          background-color: #e2e2e2 !important;
        }
        &:last-child{
          &:before{
            display:none;
          }
        }
      }
    }
  }
  .graph-btn-category{
    display:flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    z-index:0;
    position:relative;
    padding: 5px 10px 0;
    color:#fff;
    &.color--0,
    &.color--1,
    &.color--2{
      
    }
    &.color--0{
      //border-top:1px solid #7366f0;
      //background-color:#7366f0;
      border-top:1px solid #ff9f43;
      background-color:#ff9f43;
    }
    &.color--1{
      //border-top:1px solid #26AE90;
      //background-color:#26AE90;
      border-top:1px solid #7366f0;
      background-color:#7366f0;
      .vs-button{
        &:before{
          border-top:1px solid #7366f0;
        }
        &.count_new{
          display:none;
        }
      }
    }
    &.color--2{
      //border-top:1px solid #f3bf30;
      //background-color:#f3bf30;
      border-top:1px solid #000000;
      background-color:#000000;
      .vs-button{
        &:before{
          border-top:1px solid #f3bf30;
        }
        &.count_used{
          display:none;
        }
      }
    }
    .vs-button{
      overflow: visible;
      position: relative;
      margin: 0 0 5px 20px;
      padding: 5px 10px !important;
      background-color:transparent !important;
      border-bottom:none;
      color:#fff !important;
      transition: unset;
      &:disabled{
        opacity:1;
      }
      &:hover,
      &.is-active{
        box-shadow: none;
        background-color: #fff !important;
        color:#333 !important;
      }
      &:before{
        content:"";
        display:block;
        position: absolute;
        top:50%;
        left:-10px;
        transform: translate(0,-50%);
        height: 50%;
        border-right:1px solid #fff;
      }
      &:first-child{
        margin-left:0;
        &:before{
          display:none;
        }
      }
      .vs-button--text{
        transition: unset;
      }
    }
    .item-btn{
      
      .vs-button{
        
        
      }
    }
  }

  .graph-item-detail{
    .vx-card__body{
      padding: 0 !important;
    }
  }

  .icon-btn{
    .vs-button-text{
      display: flex;
      align-items:center;
      align-content: center;
    }
    .icon{
      .size-s{
        width:15px;
      }
    }  
  }

  

  #searchContainer{
    min-height: inherit;
  }
  .input-prompt-wrap{
    //max-width:500px;
    //margin:0 auto;
    justify-content: space-around;
    .vs-con-input-label{
      width:100%;
    }
  }
  .label-switch{
    display:flex;
  }
  .input-number-step{
    .vs-input-number{
      margin:0;
      .vs-input-number--input{
        width:calc(100% - 60px);
      }
    }
  }
  .input-number{
    .vs-inputx{
      text-align:right;
    }
  }
  .unit-input-yen{
    .vs-con-input{
      position:relative;
      width:calc(100% - 1.3em);
      &:after{
        content:"円";
        position: absolute;
        top: 50%;
        right:-1.3em;
        transform:translate(0,-50%);
      }  
    }
  }
  .unit-yen{
    position:relative;
    width:calc(100% - 1.3em);
    text-align: right;
    &:after{
      content:"円";
      position: absolute;
      top: 50%;
      right:-1.3em;
      transform:translate(0,-50%);
    }  
  }
  .confirm-wrap{
    dl{
      margin-top:10px;
      &:first-child{
        margin-top:0;
      }
      dt,dd{
        padding:5px 10px;
      }
      dt{
        border-radius:5px;
        background-color:#f5f5f5;
        font-weight:bold;
      }
      dd{
        //margin-top:5px;
      }
    }
  }

  .con-vs-dialog{
    z-index:54000;
    .vs-dialog{
      max-height: 100vh;
      //overflow-y: scroll;
      //overflow-x: hidden;
    }
  }

  .chart{
    width:100%;
    height:200px;
  }
  .highcharts-title{
    display: block;
    //padding: 3px 5px !important;
    //border: 1px solid #ccc !important;
    //border-radius:4px !important;
    //background-color: #fff !important;
    //color: #ccc !important;
    font-size:14px !important;
    font-weight:bold !important;
  }
  .tooltip-date{
    display:flex;
    justify-content: center;
    align-items:center;
    .date{

    }
    .hour{
      margin-left:10px;
    }
  }
  .highcharts-tooltip{
    > span {
      background: rgba(255,255,255,0.85);
      border: 1px solid silver;
      border-radius: 3px;
      box-shadow: 1px 1px 2px #888;
      padding: 8px;
      text-align:center;
    }
  
    .tooltip-inner{
      display:flex;
      align-items:center;
      justify-content: space-between;
      padding: 2px 0;
      .ttl{
        display:flex;
        align-items:center;
        text-align: left;
        &[data-symbol="circle"]{
          &:before{
            content: "●";
          }
        }
        &[data-symbol="diamond"]{
          &:before{
            content: "♦";
          }
        }
        &[data-symbol="square"]{
          &:before{
            content: "■";
          }
        }
        &[data-symbol="triangle"]{
          &:before{
            font-size:10px;
            content: "\025b2";
          }
        }
        &[data-symbol="triangle-down"]{
          &:before{
            font-size:9px;
            content: "\025bc";
          }
        }
        
        &:before{
          margin-right:5px;
          font-size:18px;
          font-weight:bold;
          line-height: 1;
        }
        .name{
          color:#333;
        }
      }
      .value{
        min-width: 70px;
        padding-left:5px;
        text-align: right;
      }
    }
    
  }
  .highcharts-subtitle{
    display:flex;
    justify-content:center;
    align-items:center;
    position: absolute;
    top:50% !important;
    left: 0 !important;
    transform: translate(0,-50%) !important;
    width:100%;
    height: 100%;
    background-color: rgba(255,255,255,0.7);
    text-align: center;
    font-weight:bold;
  }

  $border: 2px solid #fff;
  #cameraWrap{
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    opacity: 0;
    visibility: hidden;
    transition: all .15s linear;
    &.is-active{
      opacity:1;
      visibility: visible;
    }
    .cameraWrapInner{
      position: absolute;
      top: calc(50% + 60px);
      left: 50%;
      transform: translate(-50%,-50%);
    }
    .cameraAreaWrap{
      position: relative;
      &:before,
      &:after{
        display:block;
        content:"";
        position: absolute;
        top: -10px;
        width:20px;
        height:20px;
        border-top: $border;
      }
      &:before{
        left: -10px;
        border-left: $border;
        //border-radius: 4px 0 0 0;
      }
      &:after{
        right: -10px;
        border-right: $border;
        //border-radius: 0 4px 0 0;
      }
      .cameraAreaWrapInner{
        &:before,
        &:after{
          display:block;
          content:"";
          position: absolute;
          bottom: -10px;
          width:20px;
          height:20px;
          border-bottom: $border;
        }
        &:before{
          left: -10px;
          border-left: $border;
          //border-radius: 0 0 0 4px;
        }
        &:after{
          right: -10px;
          border-right: $border;
          //border-radius: 0 0 4px 0;
        }
      }
      #cameraArea {
        overflow: hidden;
        video{
          object-fit: cover;
        }
      }
    }
    #cameraArea {
      //overflow: hidden;
      //width: 300px;
      //height: 240px;
      margin: auto;
      position: relative;
      display: flex;
      align-items: center;
      video,
      canvas,
      .resultImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
      }
      .resultImg {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: auto;
      }
      svg{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      video{
        z-index:1;
        position: relative;
        width: 300px;
        height: 240px;
        //max-width: calc(100% - 40px);
      }
      canvas{
        z-index:3;
        //width: 300px;
        //height: 100%;
      }
      .resultImg {
        z-index:2;
      }
    }
    
    .catch{
      position: absolute;
      bottom: -5px;
      left: 0;
      transform: translate(0,100%);
      width: 100%;
      text-align: center;
      font-weight: bold;
      //font-size: 14px;
      letter-spacing: 0.1em;
      color: #fff;
    }
    button {
      //margin-top: 30px;
    }
    .btn-close{
      position: absolute;
      top: -10px;
      right: -10px;
      width: 40px;
      height: 40px;
      border-radius: 9999px;
      background-color: #fff;
      border: 2px solid #333;
      line-height:1;
      cursor: pointer;
      transition: transform .15s linear;
      transform: translate(100%,-100%)  rotate(0);
      &:hover{
        transform: translate(100%,-100%) rotate(90deg);
      }
    }
    .button{
      margin-top: 5.5em;
      text-align: center;
      >*{
        margin: 0 10px;
      }
    }
    .resultImg {
      width: 100%;
    }
    .resultCode {
      font-size: 24px;
      font-weight: bold;
      text-align: center;
    }
    .getMessage {
      color: red;
    }
  }
  .con-vs-loading{
    z-index: 1000;
  }
  .no-data{
    margin:50px auto 0;
    text-align: center;
  }

  body, html{
    @media only screen and (max-width: 768px){
      //min-width: 1200px;
      overflow-x: visible;
    }
  }
  #app{
    .vx-navbar-wrapper{
      .vs-navbar{
        @media only screen and (max-width: 768px){
          //width: 768px;
          //width: 1200px;
        }
      }
    }
    .router-view {
      @media only screen and (max-width: 768px){
        width: 900px;
        //width: 1200px;
      }
    }
  }

  .sp-block{
    display:none;
    @media only screen and (max-width: 768px){
      display:block;
    }
  }

  .nowrap{
    white-space: nowrap;
  }
  

  .itemSpecTable{
    table-layout: fixed;
    margin-top: 1px;
    border-collapse:collapse;
    tr{
      th,td{
        vertical-align:middle;
        padding: 5px 10px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        line-height: 1.4;
      }
      th{
        width:150px;
        //border-radius:2px;
        background-color:rgb(115, 103, 240);
        text-align: center;
        color:#fff;
      }
      td{
        padding-right:30px;
      }
    }
  }

  .searchCheckbox{
    display:flex;
    flex-wrap: wrap;
    width:100%;
    margin-bottom:40px;
    .vx-card {
      .vx-card__collapsible-content{
        .vx-card__body{
          padding:15px;
        }
      }
    }
    .error-message{
      padding: 10px;
      font-weight:bold;
      color: red;
      li{
        margin-top:3px;
        &:before{
          content:"・";
        }
        &:first-child{
          margin-top:0;
        }
      }
    }
  }
  .searchSubmit{
    position: relative;
    width:100%;
    margin-top:15px;
    text-align:center;
    >*{
      margin: 0 5px;
    }
    .vs-button{
      min-width: 175px;
    }
    .totalResults{
      position: absolute;
      top:50%;
      left:0;
      transform: translateY(-50%);
      font-weight: bold;
    }
  }

  .searchForm{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    //justify-content: space-around;
    .form-inner{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      align-content: center;
      width: calc(100% / 4 - 10px);
      padding: 0 10px 10px;
      .ttl{
        width:100%;
        margin-bottom:5px;
        font-weight: bold;
      }
      .input-wrap{
        width:calc(50% - 2em);
        .vs-input{
          width: 100%;
        }
        .vs-component{
          
        }
      }
      .item{
        width: 2em;
        line-height: 1;
        text-align: center;
      }
    }
    .checkbox-wrap{
      padding:1em 0 0;
      .input-wrap{
        display:flex;
        justify-content:center;
      }
      .ttl{
        margin:0;
      }
    }
    .label-wrap{
      padding: 0 10px;
      text-align: center;
      .ttl{
        margin-bottom: 0;
        font-size: 18px;
      }
    }
  }
  .sep-horizontal{
    width:100%;
    margin: 5px 10px;
    border-top: 1px solid #eee;
  }
  .searchForm02{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: center;
    justify-content: space-between;
    .form-wrap{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .form-inner{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      align-content: center;
      z-index:0;
      position: relative;
      //width: calc(100% / 4 - 10px);
      width: 100%;
      padding: 0 10px 5px;
      .ttl{
        width:100%;
        margin-bottom:5px;
        font-weight: bold;
      }
      .input-wrap{
        position:relative;
        width:calc(50% - 2em);
        .vs-input{
          width: 100%;
        }
        .vs-component{
          input{
            &:disabled{
              background-color:#ececec;
            }
          }
          
        }
        .is-error{
          .vs-input--input{
            border-color: red !important;
          }
        }
      }
      .item{
        width: 2em;
        line-height: 1;
        text-align: center;
      }
    }
    .keyword-wrap{
      z-index:10;
    }
    .category-wrap{
      z-index:9;
    }
    .checkbox-wrap{
      display:flex;
      justify-content:center;
      padding:1em 0 0;
      .input-wrap{
        
      }
      .ttl{
        margin:0;
      }
    }
    .label-wrap{
      padding: 0 10px;
      text-align: center;
      .ttl{
        margin-bottom: 0;
        font-size: 16px;
      }
    }
  }
  .search-suggest-list{
    z-index:10;
    position: absolute;
    bottom:2px;
    left:0;
    transform:translateY(100%);
    overflow-y:scroll;
    width:100%;
    max-height: 50vh;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-top:none;
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.1);
    li{
      padding: 3px 10px 3px 2em;
      cursor:pointer;
      &:hover{
        background-color:#7367f0;
        color:#fff;
      }
    }
  }
  .color-new{
    color:#26AE90;
  }
  .color-used{
    color:#f3bf30;
  }
  .vs-con-loading__container{
    overflow: visible;
  }
  .loadingSpinner{
    width: 100%;
    text-align:center;
    img{
      margin: 30px auto 0;
    }
  }
</style>
